var items = {
  "block.minecraft.acacia_button": "ປຸ່ມໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_door": "ປະຕູໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_fence": "ຮົ້ວໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_fence_gate": "ປະຕູຮົ້ວໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_leaves": "ໃບໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_log": "ຂອນໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_planks": "ແປ້ນໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_pressure_plate": "ແປ້ນຢຽບໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_sapling": "ເບ້ຍອາເຄເຊຍ",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "ປ້າຍໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_slab": "ແຜ່ນໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_stairs": "ຄັນໄດໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_trapdoor": "ປະຕູກັບດັກໄມ້ອາເຄເຊຍ",
  "block.minecraft.acacia_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ອາເຄເຊຍຕິດຝາ",
  "block.minecraft.acacia_wall_sign": "ປ້າຍໄມ້ອາເຄເຊຍຕິດຝາ",
  "block.minecraft.acacia_wood": "ໄມ້ອາເຄເຊຍ",
  "block.minecraft.activator_rail": "ລາງຈູດຊະນວນ",
  "block.minecraft.air": "ອາກາດ",
  "block.minecraft.allium": "ດອກອາວລຽມ",
  "block.minecraft.amethyst_block": "ບລ໋ອກອາເມທິສ",
  "block.minecraft.amethyst_cluster": "ພວງອາເມທິສ",
  "block.minecraft.ancient_debris": "ເສດແຮ່ບູຮານ",
  "block.minecraft.andesite": "ຫີນແອນດີໄຊທ໌",
  "block.minecraft.andesite_slab": "ແຜ່ນຫີນແອນດີໄຊທ໌",
  "block.minecraft.andesite_stairs": "ຄັນໄດຫີນແອນດີໄຊທ໌",
  "block.minecraft.andesite_wall": "ກຳແພງຫີນແອນດີໄຊທ໌",
  "block.minecraft.anvil": "ທັ່ງ",
  "block.minecraft.attached_melon_stem": "ລຳຕົ້ນໝາກໂມແນບຕິດ",
  "block.minecraft.attached_pumpkin_stem": "ລຳຕົ້ນໝາກອຶແນບຕິດ",
  "block.minecraft.azalea": "ກຸຫຼາບພັນປີ",
  "block.minecraft.azalea_leaves": "ໃບກຸຫຼາບພັນປີ",
  "block.minecraft.azure_bluet": "ດອກອາຊົວບລູເອັດ",
  "block.minecraft.bamboo": "ໄມ້ໄຜ່",
  "block.minecraft.bamboo_block": "ບລ໋ອກໄມ້ໄຜ່",
  "block.minecraft.bamboo_button": "ປຸ່ມໄມ້ໄຜ່",
  "block.minecraft.bamboo_door": "ປະຕູໄມ້ໄຜ່",
  "block.minecraft.bamboo_fence": "ຮົ້ວໄມ້ໄຜ່",
  "block.minecraft.bamboo_fence_gate": "ປະຕູຮົ້ວໄມ້ໄຜ່",
  "block.minecraft.bamboo_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໄຜ່",
  "block.minecraft.bamboo_mosaic": "ໄມ້ໄຜ່ສານ",
  "block.minecraft.bamboo_mosaic_slab": "ແຜ່ນໄມ້ໄຜ່ສານ",
  "block.minecraft.bamboo_mosaic_stairs": "ຄັນໄດໄມ້ໄຜ່ສານ",
  "block.minecraft.bamboo_planks": "ແປ້ນໄມ້ໄຜ່",
  "block.minecraft.bamboo_pressure_plate": "ແປ້ນຢຽບໄມ້ໄຜ່",
  "block.minecraft.bamboo_sapling": "ໜໍ່ໄມ້",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "ປ້າຍໄມ້ໄຜ່",
  "block.minecraft.bamboo_slab": "ແຜ່ນໄມ້ໄຜ່",
  "block.minecraft.bamboo_stairs": "ຄັນໄດໄມ້ໄຜ່",
  "block.minecraft.bamboo_trapdoor": "ປະຕູກັບດັກໄມ້ໄຜ່",
  "block.minecraft.bamboo_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໄຜ່ຕິດຝາ",
  "block.minecraft.bamboo_wall_sign": "ປ້າຍໄມ້ໄຜ່ຕິດຝາ",
  "block.minecraft.banner.base.black": "ສີດຳໝົດຜືນ",
  "block.minecraft.banner.base.blue": "ສີຟ້າໝົດຜືນ",
  "block.minecraft.banner.base.brown": "ສີນ້ຳຕານໝົດຜືນ",
  "block.minecraft.banner.base.cyan": "ສີຟ້າໃສໝົດຜືນ",
  "block.minecraft.banner.base.gray": "ສີເທົາໝົດຜືນ",
  "block.minecraft.banner.base.green": "ສີຂຽວໝົດຜືນ",
  "block.minecraft.banner.base.light_blue": "ສີຟ້າອ່ອນໝົດຜືນ",
  "block.minecraft.banner.base.light_gray": "ສີເທົາອ່ອນໝົດຜືນ",
  "block.minecraft.banner.base.lime": "ສີຂຽວອ່ອນໝົດຜືນ",
  "block.minecraft.banner.base.magenta": "ສີມ້ວງແດງໝົດຜືນ",
  "block.minecraft.banner.base.orange": "ສີສົ້ມໝົດຜືນ",
  "block.minecraft.banner.base.pink": "ສີບົວໝົດຜືນ",
  "block.minecraft.banner.base.purple": "ສີມ້ວງໝົດຜືນ",
  "block.minecraft.banner.base.red": "ສີແດງໝົດຜືນ",
  "block.minecraft.banner.base.white": "ສີຂາວໝົດຜືນ",
  "block.minecraft.banner.base.yellow": "ສີເຫຼືອງໝົດຜືນ",
  "block.minecraft.banner.border.black": "ຂອບສີດຳ",
  "block.minecraft.banner.border.blue": "ຂອບສີຟ້າ",
  "block.minecraft.banner.border.brown": "ຂອບສີນ້ຳຕານ",
  "block.minecraft.banner.border.cyan": "ຂອບສີຟ້າໃສ",
  "block.minecraft.banner.border.gray": "ຂອບສີເທົາ",
  "block.minecraft.banner.border.green": "ຂອບສີຂຽວ",
  "block.minecraft.banner.border.light_blue": "ຂອບສີຟ້າອ່ອນ",
  "block.minecraft.banner.border.light_gray": "ຂອບສີເທົາອ່ອນ",
  "block.minecraft.banner.border.lime": "ຂອບສີຂຽວອ່ອນ",
  "block.minecraft.banner.border.magenta": "ຂອບສີມ້ວງແດງ",
  "block.minecraft.banner.border.orange": "ຂອບສີສົ້ມ",
  "block.minecraft.banner.border.pink": "ຂອບສີບົວ",
  "block.minecraft.banner.border.purple": "ຂອບສີມ້ວງ",
  "block.minecraft.banner.border.red": "ຂອບສີແດງ",
  "block.minecraft.banner.border.white": "ຂອບສີຂາວ",
  "block.minecraft.banner.border.yellow": "ຂອບສີເຫຼືອງ",
  "block.minecraft.banner.bricks.black": "ລາຍດິນຈີ່ສີດຳ",
  "block.minecraft.banner.bricks.blue": "ລາຍດິນຈີ່ສີຟ້າ",
  "block.minecraft.banner.bricks.brown": "ລາຍດິນຈີ່ສີນ້ຳຕານ",
  "block.minecraft.banner.bricks.cyan": "ລາຍດິນຈີ່ສີຟ້າໃສ",
  "block.minecraft.banner.bricks.gray": "ລາຍດິນຈີ່ສີເທົາ",
  "block.minecraft.banner.bricks.green": "ລາຍດິນຈີ່ສີຂຽວ",
  "block.minecraft.banner.bricks.light_blue": "ລາຍດິນຈີ່ສີຟ້າອ່ອນ",
  "block.minecraft.banner.bricks.light_gray": "ລາຍດິນຈີ່ສີເທົາອ່ອນ",
  "block.minecraft.banner.bricks.lime": "ລາຍດິນຈີ່ສີຂຽວອ່ອນ",
  "block.minecraft.banner.bricks.magenta": "ລາຍດິນຈີ່ສີມ້ວງແດງ",
  "block.minecraft.banner.bricks.orange": "ລາຍດິນຈີ່ສີສົ້ມ",
  "block.minecraft.banner.bricks.pink": "ລາຍດິນຈີ່ສີບົວ",
  "block.minecraft.banner.bricks.purple": "ລາຍດິນຈີ່ສີມ້ວງ",
  "block.minecraft.banner.bricks.red": "ລາຍດິນຈີ່ສີແດງ",
  "block.minecraft.banner.bricks.white": "ລາຍດິນຈີ່ສີຂາວ",
  "block.minecraft.banner.bricks.yellow": "ລາຍດິນຈີ່ສີເຫຼືອງ",
  "block.minecraft.banner.circle.black": "ວົງມົນສີດຳ",
  "block.minecraft.banner.circle.blue": "ວົງມົນສີຟ້າ",
  "block.minecraft.banner.circle.brown": "ວົງມົນສີນ້ຳຕານ",
  "block.minecraft.banner.circle.cyan": "ວົງມົນສີຟ້າໃສ",
  "block.minecraft.banner.circle.gray": "ວົງມົນສີເທົາ",
  "block.minecraft.banner.circle.green": "ວົງມົນສີຂຽວ",
  "block.minecraft.banner.circle.light_blue": "ວົງມົນສີຟ້າອ່ອນ",
  "block.minecraft.banner.circle.light_gray": "ວົງມົນສີເທົາອ່ອນ",
  "block.minecraft.banner.circle.lime": "ວົງມົນສີຂຽວອ່ອນ",
  "block.minecraft.banner.circle.magenta": "ວົງມົນສີມ້ວງແດງ",
  "block.minecraft.banner.circle.orange": "ວົງມົນສີສົ້ມ",
  "block.minecraft.banner.circle.pink": "ວົງມົນສີບົວ",
  "block.minecraft.banner.circle.purple": "ວົງມົນສີມ້ວງ",
  "block.minecraft.banner.circle.red": "ວົງມົນສີແດງ",
  "block.minecraft.banner.circle.white": "ວົງມົນສີຂາວ",
  "block.minecraft.banner.circle.yellow": "ວົງມົນສີເຫຼືອງ",
  "block.minecraft.banner.creeper.black": "ກາສັນຍະລັກຄຣີບເປີສີດຳ",
  "block.minecraft.banner.creeper.blue": "ກາສັນຍະລັກຄຣີບເປີສີຟ້າ",
  "block.minecraft.banner.creeper.brown": "ກາສັນຍະລັກຄຣີບເປີສີນ້ຳຕານ",
  "block.minecraft.banner.creeper.cyan": "ກາສັນຍະລັກຄຣີບເປີສີຟ້າໃສ",
  "block.minecraft.banner.creeper.gray": "ກາສັນຍະລັກຄຣີບເປີສີເທົາ",
  "block.minecraft.banner.creeper.green": "ກາສັນຍະລັກຄຣີບເປີສີຂຽວ",
  "block.minecraft.banner.creeper.light_blue": "ກາສັນຍະລັກຄຣີບເປີສີຟ້າອ່ອນ",
  "block.minecraft.banner.creeper.light_gray": "ກາສັນຍະລັກຄຣີບເປີສີເທົາອ່ອນ",
  "block.minecraft.banner.creeper.lime": "ກາສັນຍະລັກຄຣີບເປີສີຂຽວອ່ອນ",
  "block.minecraft.banner.creeper.magenta": "ກາສັນຍະລັກຄຣີບເປີສີມ້ວງແດງ",
  "block.minecraft.banner.creeper.orange": "ກາສັນຍະລັກຄຣີບເປີສີສົ້ມ",
  "block.minecraft.banner.creeper.pink": "ກາສັນຍະລັກຄຣີບເປີສີບົວ",
  "block.minecraft.banner.creeper.purple": "ກາສັນຍະລັກຄຣີບເປີສີມ້ວງ",
  "block.minecraft.banner.creeper.red": "ກາສັນຍະລັກຄຣີບເປີສີແດງ",
  "block.minecraft.banner.creeper.white": "ກາສັນຍະລັກຄຣີບເປີສີຂາວ",
  "block.minecraft.banner.creeper.yellow": "ກາສັນຍະລັກຄຣີບເປີສີເຫຼືອງ",
  "block.minecraft.banner.cross.black": "ໂຕເອັກສີດຳ",
  "block.minecraft.banner.cross.blue": "ໂຕເອັກສີຟ້າ",
  "block.minecraft.banner.cross.brown": "ໂຕເອັກສີນ້ຳຕານ",
  "block.minecraft.banner.cross.cyan": "ໂຕເອັກສີຟ້າໃສ",
  "block.minecraft.banner.cross.gray": "ໂຕເອັກສີເທົາ",
  "block.minecraft.banner.cross.green": "ໂຕເອັກສີຂຽວ",
  "block.minecraft.banner.cross.light_blue": "ໂຕເອັກສີຟ້າອ່ອນ",
  "block.minecraft.banner.cross.light_gray": "ໂຕເອັກສີເທົາອ່ອນ",
  "block.minecraft.banner.cross.lime": "ໂຕເອັກສີຂຽວອ່ອນ",
  "block.minecraft.banner.cross.magenta": "ໂຕເອັກສີມ້ວງແດງ",
  "block.minecraft.banner.cross.orange": "ໂຕເອັກສີສົ້ມ",
  "block.minecraft.banner.cross.pink": "ໂຕເອັກສີບົວ",
  "block.minecraft.banner.cross.purple": "ໂຕເອັກສີມ້ວງ",
  "block.minecraft.banner.cross.red": "ໂຕເອັກສີແດງ",
  "block.minecraft.banner.cross.white": "ໂຕເອັກສີຂາວ",
  "block.minecraft.banner.cross.yellow": "ໂຕເອັກສີເຫຼືອງ",
  "block.minecraft.banner.curly_border.black": "ຂອບຮອຍຫຍໍ່ສີດຳ",
  "block.minecraft.banner.curly_border.blue": "ຂອບຮອຍຫຍໍ່ສີຟ້າ",
  "block.minecraft.banner.curly_border.brown": "ຂອບຮອຍຫຍໍ່ສີນ້ຳຕານ",
  "block.minecraft.banner.curly_border.cyan": "ຂອບຮອຍຫຍໍ່ສີຟ້າໃສ",
  "block.minecraft.banner.curly_border.gray": "ຂອບຮອຍຫຍໍ່ສີເທົາ",
  "block.minecraft.banner.curly_border.green": "ຂອບຮອຍຫຍໍ່ສີຂຽວ",
  "block.minecraft.banner.curly_border.light_blue": "ຂອບຮອຍຫຍໍ່ສີຟ້າອ່ອນ",
  "block.minecraft.banner.curly_border.light_gray": "ຂອບຮອຍຫຍໍ່ສີເທົາອ່ອນ",
  "block.minecraft.banner.curly_border.lime": "ຂອບຮອຍຫຍໍ່ສີຂຽວອ່ອນ",
  "block.minecraft.banner.curly_border.magenta": "ຂອບຮອຍຫຍໍ່ສີມ້ວງແດງ",
  "block.minecraft.banner.curly_border.orange": "ຂອບຮອຍຫຍໍ່ສີສົ້ມ",
  "block.minecraft.banner.curly_border.pink": "ຂອບຮອຍຫຍໍ່ສີບົວ",
  "block.minecraft.banner.curly_border.purple": "ຂອບຮອຍຫຍໍ່ສີມ້ວງ",
  "block.minecraft.banner.curly_border.red": "ຂອບຮອຍຫຍໍ່ສີແດງ",
  "block.minecraft.banner.curly_border.white": "ຂອບຮອຍຫຍໍ່ສີຂາວ",
  "block.minecraft.banner.curly_border.yellow": "ຂອບຮອຍຫຍໍ່ສີເຫຼືອງ",
  "block.minecraft.banner.diagonal_left.black": "ມຸມຂວາງຊ້າຍສີດຳ",
  "block.minecraft.banner.diagonal_left.blue": "ມຸມຂວາງຊ້າຍສີຟ້າ",
  "block.minecraft.banner.diagonal_left.brown": "ມຸມຂວາງຊ້າຍສີນ້ຳຕານ",
  "block.minecraft.banner.diagonal_left.cyan": "ມຸມຂວາງຊ້າຍສີຟ້າໃສ",
  "block.minecraft.banner.diagonal_left.gray": "ມຸມຂວາງຊ້າຍສີເທົາ",
  "block.minecraft.banner.diagonal_left.green": "ມຸມຂວາງຊ້າຍສີຂຽວ",
  "block.minecraft.banner.diagonal_left.light_blue": "ມຸມຂວາງຊ້າຍສີຟ້າອ່ອນ",
  "block.minecraft.banner.diagonal_left.light_gray": "ມຸມຂວາງຊ້າຍສີເທົາອ່ອນ",
  "block.minecraft.banner.diagonal_left.lime": "ມຸມຂວາງຊ້າຍສີຂຽວອ່ອນ",
  "block.minecraft.banner.diagonal_left.magenta": "ມຸມຂວາງຊ້າຍສີມ້ວງແດງ",
  "block.minecraft.banner.diagonal_left.orange": "ມຸມຂວາງຊ້າຍສີສົ້ມ",
  "block.minecraft.banner.diagonal_left.pink": "ມຸມຂວາງຊ້າຍສີບົວ",
  "block.minecraft.banner.diagonal_left.purple": "ມຸມຂວາງຊ້າຍສີມ້ວງ",
  "block.minecraft.banner.diagonal_left.red": "ມຸມຂວາງຊ້າຍສີແດງ",
  "block.minecraft.banner.diagonal_left.white": "ມຸມຂວາງຊ້າຍສີຂາວ",
  "block.minecraft.banner.diagonal_left.yellow": "ມຸມຂວາງຊ້າຍສີເຫຼືອງ",
  "block.minecraft.banner.diagonal_right.black": "ມຸມຂວາງຂວາສີດຳ",
  "block.minecraft.banner.diagonal_right.blue": "ມຸມຂວາງຂວາສີຟ້າ",
  "block.minecraft.banner.diagonal_right.brown": "ມຸມຂວາງຂວາສີນ້ຳຕານ",
  "block.minecraft.banner.diagonal_right.cyan": "ມຸມຂວາງຂວາສີຟ້າໃສ",
  "block.minecraft.banner.diagonal_right.gray": "ມຸມຂວາງຂວາສີເທົາ",
  "block.minecraft.banner.diagonal_right.green": "ມຸມຂວາງຂວາສີຂຽວ",
  "block.minecraft.banner.diagonal_right.light_blue": "ມຸມຂວາງຂວາສີຟ້າອ່ອນ",
  "block.minecraft.banner.diagonal_right.light_gray": "ມຸມຂວາງຂວາສີເທົາອ່ອນ",
  "block.minecraft.banner.diagonal_right.lime": "ມຸມຂວາງຂວາສີຂຽວອ່ອນ",
  "block.minecraft.banner.diagonal_right.magenta": "ມຸມຂວາງຂວາສີມ້ວງແດງ",
  "block.minecraft.banner.diagonal_right.orange": "ມຸມຂວາງຂວາສີສົ້ມ",
  "block.minecraft.banner.diagonal_right.pink": "ມຸມຂວາງຂວາສີບົວ",
  "block.minecraft.banner.diagonal_right.purple": "ມຸມຂວາງຂວາສີມ້ວງ",
  "block.minecraft.banner.diagonal_right.red": "ມຸມຂວາງຂວາສີແດງ",
  "block.minecraft.banner.diagonal_right.white": "ມຸມຂວາງຂວາສີຂາວ",
  "block.minecraft.banner.diagonal_right.yellow": "ມຸມຂວາງຂວາສີເຫຼືອງ",
  "block.minecraft.banner.diagonal_up_left.black": "ມຸມຂວາງຊ້າຍລຸ່ມສີດຳ",
  "block.minecraft.banner.diagonal_up_left.blue": "ມຸມຂວາງຊ້າຍລຸ່ມສີຟ້າ",
  "block.minecraft.banner.diagonal_up_left.brown": "ມຸມຂວາງຊ້າຍລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.diagonal_up_left.cyan": "ມຸມຂວາງຊ້າຍລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.diagonal_up_left.gray": "ມຸມຂວາງຊ້າຍລຸ່ມສີເທົາ",
  "block.minecraft.banner.diagonal_up_left.green": "ມຸມຂວາງຊ້າຍລຸ່ມສີຂຽວ",
  "block.minecraft.banner.diagonal_up_left.light_blue": "ມຸມຂວາງຊ້າຍລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.diagonal_up_left.light_gray": "ມຸມຂວາງຊ້າຍລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.diagonal_up_left.lime": "ມຸມຂວາງຊ້າຍລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.diagonal_up_left.magenta": "ມຸມຂວາງຊ້າຍລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.diagonal_up_left.orange": "ມຸມຂວາງຊ້າຍລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.diagonal_up_left.pink": "ມຸມຂວາງຊ້າຍລຸ່ມສີບົວ",
  "block.minecraft.banner.diagonal_up_left.purple": "ມຸມຂວາງຊ້າຍລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.diagonal_up_left.red": "ມຸມຂວາງຊ້າຍລຸ່ມສີແດງ",
  "block.minecraft.banner.diagonal_up_left.white": "ມຸມຂວາງຊ້າຍລຸ່ມສີຂາວ",
  "block.minecraft.banner.diagonal_up_left.yellow": "ມຸມຂວາງຊ້າຍລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.diagonal_up_right.black": "ມຸມຂວາງຂວາລຸ່ມສີດຳ",
  "block.minecraft.banner.diagonal_up_right.blue": "ມຸມຂວາງຂວາລຸ່ມສີຟ້າ",
  "block.minecraft.banner.diagonal_up_right.brown": "ມຸມຂວາງຂວາລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.diagonal_up_right.cyan": "ມຸມຂວາງຂວາລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.diagonal_up_right.gray": "ມຸມຂວາງຂວາລຸ່ມສີເທົາ",
  "block.minecraft.banner.diagonal_up_right.green": "ມຸມຂວາງຂວາລຸ່ມສີຂຽວ",
  "block.minecraft.banner.diagonal_up_right.light_blue": "ມຸມຂວາງຂວາລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.diagonal_up_right.light_gray": "ມຸມຂວາງຂວາລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.diagonal_up_right.lime": "ມຸມຂວາງຂວາລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.diagonal_up_right.magenta": "ມຸມຂວາງຂວາລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.diagonal_up_right.orange": "ມຸມຂວາງຂວາລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.diagonal_up_right.pink": "ມຸມຂວາງຂວາລຸ່ມສີບົວ",
  "block.minecraft.banner.diagonal_up_right.purple": "ມຸມຂວາງຂວາລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.diagonal_up_right.red": "ມຸມຂວາງຂວາລຸ່ມສີແດງ",
  "block.minecraft.banner.diagonal_up_right.white": "ມຸມຂວາງຂວາລຸ່ມສີຂາວ",
  "block.minecraft.banner.diagonal_up_right.yellow": "ມຸມຂວາງຂວາລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.flow.black": "ໜ່ວຍໂລກສີດຳ",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "ກາສັນຍະລັກດອກໄມ້ສີດຳ",
  "block.minecraft.banner.flower.blue": "ກາສັນຍະລັກດອກໄມ້ສີຟ້າ",
  "block.minecraft.banner.flower.brown": "ກາສັນຍະລັກດອກໄມ້ສີນ້ຳຕານ",
  "block.minecraft.banner.flower.cyan": "ກາສັນຍະລັກດອກໄມ້ສີຟ້າໃສ",
  "block.minecraft.banner.flower.gray": "ກາສັນຍະລັກດອກໄມ້ສີເທົາ",
  "block.minecraft.banner.flower.green": "ກາສັນຍະລັກດອກໄມ້ສີຂຽວ",
  "block.minecraft.banner.flower.light_blue": "ກາສັນຍະລັກດອກໄມ້ສີຟ້າອ່ອນ",
  "block.minecraft.banner.flower.light_gray": "ກາສັນຍະລັກດອກໄມ້ສີເທົາອ່ອນ",
  "block.minecraft.banner.flower.lime": "ກາສັນຍະລັກດອກໄມ້ສີຂຽວອ່ອນ",
  "block.minecraft.banner.flower.magenta": "ກາສັນຍະລັກດອກໄມ້ສີມ້ວງແດງ",
  "block.minecraft.banner.flower.orange": "ກາສັນຍະລັກດອກໄມ້ສີສົ້ມ",
  "block.minecraft.banner.flower.pink": "ກາສັນຍະລັກດອກໄມ້ສີບົວ",
  "block.minecraft.banner.flower.purple": "ກາສັນຍະລັກດອກໄມ້ສີມ້ວງ",
  "block.minecraft.banner.flower.red": "ກາສັນຍະລັກດອກໄມ້ສີແດງ",
  "block.minecraft.banner.flower.white": "ກາສັນຍະລັກດອກໄມ້ສີຂາວ",
  "block.minecraft.banner.flower.yellow": "ກາສັນຍະລັກດອກໄມ້ສີເຫຼືອງ",
  "block.minecraft.banner.globe.black": "ໜ່ວຍໂລກສີດຳ",
  "block.minecraft.banner.globe.blue": "ໜ່ວຍໂລກສີຟ້າ",
  "block.minecraft.banner.globe.brown": "ໜ່ວຍໂລກສີນ້ຳຕານ",
  "block.minecraft.banner.globe.cyan": "ໜ່ວຍໂລກສີຟ້າໃສ",
  "block.minecraft.banner.globe.gray": "ໜ່ວຍໂລກສີເທົາ",
  "block.minecraft.banner.globe.green": "ໜ່ວຍໂລກສີຂຽວ",
  "block.minecraft.banner.globe.light_blue": "ໜ່ວຍໂລກສີຟ້າອ່ອນ",
  "block.minecraft.banner.globe.light_gray": "ໜ່ວຍໂລກສີເທົາອ່ອນ",
  "block.minecraft.banner.globe.lime": "ໜ່ວຍໂລກສີຂຽວອ່ອນ",
  "block.minecraft.banner.globe.magenta": "ໜ່ວຍໂລກສີມ້ວງແດງ",
  "block.minecraft.banner.globe.orange": "ໜ່ວຍໂລກສີສົ້ມ",
  "block.minecraft.banner.globe.pink": "ໜ່ວຍໂລກສີບົວ",
  "block.minecraft.banner.globe.purple": "ໜ່ວຍໂລກສີມ້ວງ",
  "block.minecraft.banner.globe.red": "ໜ່ວຍໂລກສີແດງ",
  "block.minecraft.banner.globe.white": "ໜ່ວຍໂລກສີຂາວ",
  "block.minecraft.banner.globe.yellow": "ໜ່ວຍໂລກສີເຫຼືອງ",
  "block.minecraft.banner.gradient.black": "ໄລ່ລຳດັບສີດຳ",
  "block.minecraft.banner.gradient.blue": "ໄລ່ລຳດັບສີຟ້າ",
  "block.minecraft.banner.gradient.brown": "ໄລ່ລຳດັບສີນ້ຳຕານ",
  "block.minecraft.banner.gradient.cyan": "ໄລ່ລຳດັບສີຟ້າໃສ",
  "block.minecraft.banner.gradient.gray": "ໄລ່ລຳດັບສີເທົາ",
  "block.minecraft.banner.gradient.green": "ໄລ່ລຳດັບສີຂຽວ",
  "block.minecraft.banner.gradient.light_blue": "ໄລ່ລຳດັບສີຟ້າອ່ອນ",
  "block.minecraft.banner.gradient.light_gray": "ໄລ່ລຳດັບສີເທົາອ່ອນ",
  "block.minecraft.banner.gradient.lime": "ໄລ່ລຳດັບສີຂຽວອ່ອນ",
  "block.minecraft.banner.gradient.magenta": "ໄລ່ລຳດັບສີມ້ວງແດງ",
  "block.minecraft.banner.gradient.orange": "ໄລ່ລຳດັບສີສົ້ມ",
  "block.minecraft.banner.gradient.pink": "ໄລ່ລຳດັບສີບົວ",
  "block.minecraft.banner.gradient.purple": "ໄລ່ລຳດັບສີມ້ວງ",
  "block.minecraft.banner.gradient.red": "ໄລ່ລຳດັບສີແດງ",
  "block.minecraft.banner.gradient.white": "ໄລ່ລຳດັບສີຂາວ",
  "block.minecraft.banner.gradient.yellow": "ໄລ່ລຳດັບສີເຫຼືອງ",
  "block.minecraft.banner.gradient_up.black": "ໄລ່ລຳດັບຈາກພື້ນສີດຳ",
  "block.minecraft.banner.gradient_up.blue": "ໄລ່ລຳດັບຈາກພື້ນສີຟ້າ",
  "block.minecraft.banner.gradient_up.brown": "ໄລ່ລຳດັບຈາກພື້ນສີນ້ຳຕານ",
  "block.minecraft.banner.gradient_up.cyan": "ໄລ່ລຳດັບຈາກພື້ນສີຟ້າໃສ",
  "block.minecraft.banner.gradient_up.gray": "ໄລ່ລຳດັບຈາກພື້ນສີເທົາ",
  "block.minecraft.banner.gradient_up.green": "ໄລ່ລຳດັບຈາກພື້ນສີຂຽວ",
  "block.minecraft.banner.gradient_up.light_blue": "ໄລ່ລຳດັບຈາກພື້ນສີຟ້າອ່ອນ",
  "block.minecraft.banner.gradient_up.light_gray": "ໄລ່ລຳດັບຈາກພື້ນສີເທົາອ່ອນ",
  "block.minecraft.banner.gradient_up.lime": "ໄລ່ລຳດັບຈາກພື້ນສີຂຽວອ່ອນ",
  "block.minecraft.banner.gradient_up.magenta": "ໄລ່ລຳດັບຈາກພື້ນສີມ້ວງແດງ",
  "block.minecraft.banner.gradient_up.orange": "ໄລ່ລຳດັບຈາກພື້ນສີສົ້ມ",
  "block.minecraft.banner.gradient_up.pink": "ໄລ່ລຳດັບຈາກພື້ນສີບົວ",
  "block.minecraft.banner.gradient_up.purple": "ໄລ່ລຳດັບຈາກພື້ນສີມ້ວງ",
  "block.minecraft.banner.gradient_up.red": "ໄລ່ລຳດັບຈາກພື້ນສີແດງ",
  "block.minecraft.banner.gradient_up.white": "ໄລ່ລຳດັບຈາກພື້ນສີຂາວ",
  "block.minecraft.banner.gradient_up.yellow": "ໄລ່ລຳດັບຈາກພື້ນສີເຫຼືອງ",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "ເຄິ່ງເທິງສີດຳ",
  "block.minecraft.banner.half_horizontal.blue": "ເຄິ່ງເທິງສີຟ້າ",
  "block.minecraft.banner.half_horizontal.brown": "ເຄິ່ງເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.half_horizontal.cyan": "ເຄິ່ງເທິງສີຟ້າໃສ",
  "block.minecraft.banner.half_horizontal.gray": "ເຄິ່ງເທິງສີເທົາ",
  "block.minecraft.banner.half_horizontal.green": "ເຄິ່ງເທິງສີຂຽວ",
  "block.minecraft.banner.half_horizontal.light_blue": "ເຄິ່ງເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.half_horizontal.light_gray": "ເຄິ່ງເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.half_horizontal.lime": "ເຄິ່ງເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.half_horizontal.magenta": "ເຄິ່ງເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.half_horizontal.orange": "ເຄິ່ງເທິງສີສົ້ມ",
  "block.minecraft.banner.half_horizontal.pink": "ເຄິ່ງເທິງສີບົວ",
  "block.minecraft.banner.half_horizontal.purple": "ເຄິ່ງເທິງສີມ້ວງ",
  "block.minecraft.banner.half_horizontal.red": "ເຄິ່ງເທິງສີແດງ",
  "block.minecraft.banner.half_horizontal.white": "ເຄິ່ງເທິງສີຂາວ",
  "block.minecraft.banner.half_horizontal.yellow": "ເຄິ່ງເທິງສີເຫຼືອງ",
  "block.minecraft.banner.half_horizontal_bottom.black": "ເຄິ່ງລຸ່ມສີດຳ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ເຄິ່ງລຸ່ມສີຟ້າ",
  "block.minecraft.banner.half_horizontal_bottom.brown": "ເຄິ່ງລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "ເຄິ່ງລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.half_horizontal_bottom.gray": "ເຄິ່ງລຸ່ມສີເທົາ",
  "block.minecraft.banner.half_horizontal_bottom.green": "ເຄິ່ງລຸ່ມສີຂຽວ",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ເຄິ່ງລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ເຄິ່ງລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.half_horizontal_bottom.lime": "ເຄິ່ງລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "ເຄິ່ງລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ເຄິ່ງລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "ເຄິ່ງລຸ່ມສີບົວ",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ເຄິ່ງລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.half_horizontal_bottom.red": "ເຄິ່ງລຸ່ມສີແດງ",
  "block.minecraft.banner.half_horizontal_bottom.white": "ເຄິ່ງລຸ່ມສີຂາວ",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "ເຄິ່ງລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.half_vertical.black": "ເຄິ່ງຊ້າຍສີດຳ",
  "block.minecraft.banner.half_vertical.blue": "ເຄິ່ງຊ້າຍສີຟ້າ",
  "block.minecraft.banner.half_vertical.brown": "ເຄິ່ງຊ້າຍສີນ້ຳຕານ",
  "block.minecraft.banner.half_vertical.cyan": "ເຄິ່ງຊ້າຍສີຟ້າໃສ",
  "block.minecraft.banner.half_vertical.gray": "ເຄິ່ງຊ້າຍສີເທົາ",
  "block.minecraft.banner.half_vertical.green": "ເຄິ່ງຊ້າຍສີຂຽວ",
  "block.minecraft.banner.half_vertical.light_blue": "ເຄິ່ງຊ້າຍສີຟ້າອ່ອນ",
  "block.minecraft.banner.half_vertical.light_gray": "ເຄິ່ງຊ້າຍສີເທົາອ່ອນ",
  "block.minecraft.banner.half_vertical.lime": "ເຄິ່ງຊ້າຍສີຂຽວອ່ອນ",
  "block.minecraft.banner.half_vertical.magenta": "ເຄິ່ງຊ້າຍສີມ້ວງແດງ",
  "block.minecraft.banner.half_vertical.orange": "ເຄິ່ງຊ້າຍສີສົ້ມ",
  "block.minecraft.banner.half_vertical.pink": "ເຄິ່ງຊ້າຍສີບົວ",
  "block.minecraft.banner.half_vertical.purple": "ເຄິ່ງຊ້າຍສີມ້ວງ",
  "block.minecraft.banner.half_vertical.red": "ເຄິ່ງຊ້າຍສີແດງ",
  "block.minecraft.banner.half_vertical.white": "ເຄິ່ງຊ້າຍສີຂາວ",
  "block.minecraft.banner.half_vertical.yellow": "ເຄິ່ງຊ້າຍສີເຫຼືອງ",
  "block.minecraft.banner.half_vertical_right.black": "ເຄິ່ງຂວາສີດຳ",
  "block.minecraft.banner.half_vertical_right.blue": "ເຄິ່ງຂວາສີຟ້າ",
  "block.minecraft.banner.half_vertical_right.brown": "ເຄິ່ງຂວາສີນ້ຳຕານ",
  "block.minecraft.banner.half_vertical_right.cyan": "ເຄິ່ງຂວາສີຟ້າໃສ",
  "block.minecraft.banner.half_vertical_right.gray": "ເຄິ່ງຂວາສີເທົາ",
  "block.minecraft.banner.half_vertical_right.green": "ເຄິ່ງຂວາສີຂຽວ",
  "block.minecraft.banner.half_vertical_right.light_blue": "ເຄິ່ງຂວາສີຟ້າອ່ອນ",
  "block.minecraft.banner.half_vertical_right.light_gray": "ເຄິ່ງຂວາສີເທົາອ່ອນ",
  "block.minecraft.banner.half_vertical_right.lime": "ເຄິ່ງຂວາສີຂຽວອ່ອນ",
  "block.minecraft.banner.half_vertical_right.magenta": "ເຄິ່ງຂວາສີມ້ວງແດງ",
  "block.minecraft.banner.half_vertical_right.orange": "ເຄິ່ງຂວາສີສົ້ມ",
  "block.minecraft.banner.half_vertical_right.pink": "ເຄິ່ງຂວາສີບົວ",
  "block.minecraft.banner.half_vertical_right.purple": "ເຄິ່ງຂວາສີມ້ວງ",
  "block.minecraft.banner.half_vertical_right.red": "ເຄິ່ງຂວາສີແດງ",
  "block.minecraft.banner.half_vertical_right.white": "ເຄິ່ງຂວາສີຂາວ",
  "block.minecraft.banner.half_vertical_right.yellow": "ເຄິ່ງຂວາສີເຫຼືອງ",
  "block.minecraft.banner.mojang.black": "ໂມຈາງສີດຳ",
  "block.minecraft.banner.mojang.blue": "ໂມຈາງສີຟ້າ",
  "block.minecraft.banner.mojang.brown": "ໂມຈາງສີນ້ຳຕານ",
  "block.minecraft.banner.mojang.cyan": "ໂມຈາງສີຟ້າໃສ",
  "block.minecraft.banner.mojang.gray": "ໂມຈາງສີເທົາ",
  "block.minecraft.banner.mojang.green": "ໂມຈາງສີຂຽວ",
  "block.minecraft.banner.mojang.light_blue": "ໂມຈາງສີຟ້າອ່ອນ",
  "block.minecraft.banner.mojang.light_gray": "ໂມຈາງສີເທົາອ່ອນ",
  "block.minecraft.banner.mojang.lime": "ໂມຈາງສີຂຽວອ່ອນ",
  "block.minecraft.banner.mojang.magenta": "ໂມຈາງສີມ້ວງແດງ",
  "block.minecraft.banner.mojang.orange": "ໂມຈາງສີສົ້ມ",
  "block.minecraft.banner.mojang.pink": "ໂມຈາງສີບົວ",
  "block.minecraft.banner.mojang.purple": "ໂມຈາງສີມ້ວງ",
  "block.minecraft.banner.mojang.red": "ໂມຈາງສີແດງ",
  "block.minecraft.banner.mojang.white": "ໂມຈາງສີຂາວ",
  "block.minecraft.banner.mojang.yellow": "ໂມຈາງສີເຫຼືອງ",
  "block.minecraft.banner.piglin.black": "ດັງໝູສີດຳ",
  "block.minecraft.banner.piglin.blue": "ດັງໝູສີຟ້າ",
  "block.minecraft.banner.piglin.brown": "ດັງໝູສີນ້ຳຕານ",
  "block.minecraft.banner.piglin.cyan": "ດັງໝູສີຟ້າໃສ",
  "block.minecraft.banner.piglin.gray": "ດັງໝູສີເທົາ",
  "block.minecraft.banner.piglin.green": "ດັງໝູສີຂຽວ",
  "block.minecraft.banner.piglin.light_blue": "ດັງໝູສີຟ້າອ່ອນ",
  "block.minecraft.banner.piglin.light_gray": "ດັງໝູສີເທົາອ່ອນ",
  "block.minecraft.banner.piglin.lime": "ດັງໝູສີຂຽວອ່ອນ",
  "block.minecraft.banner.piglin.magenta": "ດັງໝູສີມ້ວງແດງ",
  "block.minecraft.banner.piglin.orange": "ດັງໝູສີສົ້ມ",
  "block.minecraft.banner.piglin.pink": "ດັງໝູສີບົວ",
  "block.minecraft.banner.piglin.purple": "ດັງໝູສີມ້ວງ",
  "block.minecraft.banner.piglin.red": "ດັງໝູສີແດງ",
  "block.minecraft.banner.piglin.white": "ດັງໝູສີຂາວ",
  "block.minecraft.banner.piglin.yellow": "ດັງໝູສີເຫຼືອງ",
  "block.minecraft.banner.rhombus.black": "ດອກຈັນຕັດສີດຳ",
  "block.minecraft.banner.rhombus.blue": "ດອກຈັນຕັດສີຟ້າ",
  "block.minecraft.banner.rhombus.brown": "ດອກຈັນຕັດສີນ້ຳຕານ",
  "block.minecraft.banner.rhombus.cyan": "ດອກຈັນຕັດສີຟ້າໃສ",
  "block.minecraft.banner.rhombus.gray": "ດອກຈັນຕັດສີເທົາ",
  "block.minecraft.banner.rhombus.green": "ດອກຈັນຕັດສີຂຽວ",
  "block.minecraft.banner.rhombus.light_blue": "ດອກຈັນຕັດສີຟ້າອ່ອນ",
  "block.minecraft.banner.rhombus.light_gray": "ດອກຈັນຕັດສີເທົາອ່ອນ",
  "block.minecraft.banner.rhombus.lime": "ດອກຈັນຕັດສີຂຽວອ່ອນ",
  "block.minecraft.banner.rhombus.magenta": "ດອກຈັນຕັດສີມ້ວງແດງ",
  "block.minecraft.banner.rhombus.orange": "ດອກຈັນຕັດສີສົ້ມ",
  "block.minecraft.banner.rhombus.pink": "ດອກຈັນຕັດສີບົວ",
  "block.minecraft.banner.rhombus.purple": "ດອກຈັນຕັດສີມ້ວງ",
  "block.minecraft.banner.rhombus.red": "ດອກຈັນຕັດສີແດງ",
  "block.minecraft.banner.rhombus.white": "ດອກຈັນຕັດສີຂາວ",
  "block.minecraft.banner.rhombus.yellow": "ດອກຈັນຕັດສີເຫຼືອງ",
  "block.minecraft.banner.skull.black": "ກາສັນຍະລັກຫົວກະໂຫຼກສີດຳ",
  "block.minecraft.banner.skull.blue": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຟ້າ",
  "block.minecraft.banner.skull.brown": "ກາສັນຍະລັກຫົວກະໂຫຼກສີນ້ຳຕານ",
  "block.minecraft.banner.skull.cyan": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຟ້າໃສ",
  "block.minecraft.banner.skull.gray": "ກາສັນຍະລັກຫົວກະໂຫຼກສີເທົາ",
  "block.minecraft.banner.skull.green": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຂຽວ",
  "block.minecraft.banner.skull.light_blue": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຟ້າອ່ອນ",
  "block.minecraft.banner.skull.light_gray": "ກາສັນຍະລັກຫົວກະໂຫຼກສີເທົາອ່ອນ",
  "block.minecraft.banner.skull.lime": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຂຽວອ່ອນ",
  "block.minecraft.banner.skull.magenta": "ກາສັນຍະລັກຫົວກະໂຫຼກສີມ້ວງແດງ",
  "block.minecraft.banner.skull.orange": "ກາສັນຍະລັກຫົວກະໂຫຼກສີສົ້ມ",
  "block.minecraft.banner.skull.pink": "ກາສັນຍະລັກຫົວກະໂຫຼກສີບົວ",
  "block.minecraft.banner.skull.purple": "ກາສັນຍະລັກຫົວກະໂຫຼກສີມ້ວງ",
  "block.minecraft.banner.skull.red": "ກາສັນຍະລັກຫົວກະໂຫຼກສີແດງ",
  "block.minecraft.banner.skull.white": "ກາສັນຍະລັກຫົວກະໂຫຼກສີຂາວ",
  "block.minecraft.banner.skull.yellow": "ກາສັນຍະລັກຫົວກະໂຫຼກສີເຫຼືອງ",
  "block.minecraft.banner.small_stripes.black": "ຮອຍຕັ້ງສີດຳ",
  "block.minecraft.banner.small_stripes.blue": "ຮອຍຕັ້ງສີຟ້າ",
  "block.minecraft.banner.small_stripes.brown": "ຮອຍຕັ້ງສີນ້ຳຕານ",
  "block.minecraft.banner.small_stripes.cyan": "ຮອຍຕັ້ງສີຟ້າໃສ",
  "block.minecraft.banner.small_stripes.gray": "ຮອຍຕັ້ງສີເທົາ",
  "block.minecraft.banner.small_stripes.green": "ຮອຍຕັ້ງສີຂຽວ",
  "block.minecraft.banner.small_stripes.light_blue": "ຮອຍຕັ້ງສີຟ້າອ່ອນ",
  "block.minecraft.banner.small_stripes.light_gray": "ຮອຍຕັ້ງສີເທົາອ່ອນ",
  "block.minecraft.banner.small_stripes.lime": "ຮອຍຕັ້ງສີຂຽວອ່ອນ",
  "block.minecraft.banner.small_stripes.magenta": "ຮອຍຕັ້ງສີມ້ວງແດງ",
  "block.minecraft.banner.small_stripes.orange": "ຮອຍຕັ້ງສີສົ້ມ",
  "block.minecraft.banner.small_stripes.pink": "ຮອຍຕັ້ງສີບົວ",
  "block.minecraft.banner.small_stripes.purple": "ຮອຍຕັ້ງສີມ້ວງ",
  "block.minecraft.banner.small_stripes.red": "ຮອຍຕັ້ງສີແດງ",
  "block.minecraft.banner.small_stripes.white": "ຮອຍຕັ້ງສີຂາວ",
  "block.minecraft.banner.small_stripes.yellow": "ຮອຍຕັ້ງສີເຫຼືອງ",
  "block.minecraft.banner.square_bottom_left.black": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີດຳ",
  "block.minecraft.banner.square_bottom_left.blue": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຟ້າ",
  "block.minecraft.banner.square_bottom_left.brown": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.square_bottom_left.cyan": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.square_bottom_left.gray": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີເທົາ",
  "block.minecraft.banner.square_bottom_left.green": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຂຽວ",
  "block.minecraft.banner.square_bottom_left.light_blue": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.square_bottom_left.light_gray": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.square_bottom_left.lime": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.square_bottom_left.magenta": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.square_bottom_left.orange": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.square_bottom_left.pink": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີບົວ",
  "block.minecraft.banner.square_bottom_left.purple": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.square_bottom_left.red": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີແດງ",
  "block.minecraft.banner.square_bottom_left.white": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີຂາວ",
  "block.minecraft.banner.square_bottom_left.yellow": "ສີ່ລ່ຽມຊ້າຍລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.square_bottom_right.black": "ສີ່ລ່ຽມຂວາລຸ່ມສີດຳ",
  "block.minecraft.banner.square_bottom_right.blue": "ສີ່ລ່ຽມຂວາລຸ່ມສີຟ້າ",
  "block.minecraft.banner.square_bottom_right.brown": "ສີ່ລ່ຽມຂວາລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.square_bottom_right.cyan": "ສີ່ລ່ຽມຂວາລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.square_bottom_right.gray": "ສີ່ລ່ຽມຂວາລຸ່ມສີເທົາ",
  "block.minecraft.banner.square_bottom_right.green": "ສີ່ລ່ຽມຂວາລຸ່ມສີຂຽວ",
  "block.minecraft.banner.square_bottom_right.light_blue": "ສີ່ລ່ຽມຂວາລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.square_bottom_right.light_gray": "ສີ່ລ່ຽມຂວາລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.square_bottom_right.lime": "ສີ່ລ່ຽມຂວາລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.square_bottom_right.magenta": "ສີ່ລ່ຽມຂວາລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.square_bottom_right.orange": "ສີ່ລ່ຽມຂວາລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.square_bottom_right.pink": "ສີ່ລ່ຽມຂວາລຸ່ມສີບົວ",
  "block.minecraft.banner.square_bottom_right.purple": "ສີ່ລ່ຽມຂວາລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.square_bottom_right.red": "ສີ່ລ່ຽມຂວາລຸ່ມສີແດງ",
  "block.minecraft.banner.square_bottom_right.white": "ສີ່ລ່ຽມຂວາລຸ່ມສີຂາວ",
  "block.minecraft.banner.square_bottom_right.yellow": "ສີ່ລ່ຽມຂວາລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.square_top_left.black": "ສີ່ລ່ຽມຊ້າຍເທິງສີດຳ",
  "block.minecraft.banner.square_top_left.blue": "ສີ່ລ່ຽມຊ້າຍເທິງສີຟ້າ",
  "block.minecraft.banner.square_top_left.brown": "ສີ່ລ່ຽມຊ້າຍເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.square_top_left.cyan": "ສີ່ລ່ຽມຊ້າຍເທິງສີຟ້າໃສ",
  "block.minecraft.banner.square_top_left.gray": "ສີ່ລ່ຽມຊ້າຍເທິງສີເທົາ",
  "block.minecraft.banner.square_top_left.green": "ສີ່ລ່ຽມຊ້າຍເທິງສີຂຽວ",
  "block.minecraft.banner.square_top_left.light_blue": "ສີ່ລ່ຽມຊ້າຍເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.square_top_left.light_gray": "ສີ່ລ່ຽມຊ້າຍເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.square_top_left.lime": "ສີ່ລ່ຽມຊ້າຍເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.square_top_left.magenta": "ສີ່ລ່ຽມຊ້າຍເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.square_top_left.orange": "ສີ່ລ່ຽມຊ້າຍເທິງສີສົ້ມ",
  "block.minecraft.banner.square_top_left.pink": "ສີ່ລ່ຽມຊ້າຍເທິງສີບົວ",
  "block.minecraft.banner.square_top_left.purple": "ສີ່ລ່ຽມຊ້າຍເທິງສີມ້ວງ",
  "block.minecraft.banner.square_top_left.red": "ສີ່ລ່ຽມຊ້າຍເທິງສີແດງ",
  "block.minecraft.banner.square_top_left.white": "ສີ່ລ່ຽມຊ້າຍເທິງສີຂາວ",
  "block.minecraft.banner.square_top_left.yellow": "ສີ່ລ່ຽມຊ້າຍເທິງສີເຫຼືອງ",
  "block.minecraft.banner.square_top_right.black": "ສີ່ລ່ຽມຂວາເທິງສີດຳ",
  "block.minecraft.banner.square_top_right.blue": "ສີ່ລ່ຽມຂວາເທິງສີຟ້າ",
  "block.minecraft.banner.square_top_right.brown": "ສີ່ລ່ຽມຂວາເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.square_top_right.cyan": "ສີ່ລ່ຽມຂວາເທິງສີຟ້າໃສ",
  "block.minecraft.banner.square_top_right.gray": "ສີ່ລ່ຽມຂວາເທິງສີເທົາ",
  "block.minecraft.banner.square_top_right.green": "ສີ່ລ່ຽມຂວາເທິງສີຂຽວ",
  "block.minecraft.banner.square_top_right.light_blue": "ສີ່ລ່ຽມຂວາເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.square_top_right.light_gray": "ສີ່ລ່ຽມຂວາເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.square_top_right.lime": "ສີ່ລ່ຽມຂວາເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.square_top_right.magenta": "ສີ່ລ່ຽມຂວາເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.square_top_right.orange": "ສີ່ລ່ຽມຂວາເທິງສີສົ້ມ",
  "block.minecraft.banner.square_top_right.pink": "ສີ່ລ່ຽມຂວາເທິງສີບົວ",
  "block.minecraft.banner.square_top_right.purple": "ສີ່ລ່ຽມຂວາເທິງສີມ້ວງ",
  "block.minecraft.banner.square_top_right.red": "ສີ່ລ່ຽມຂວາເທິງສີແດງ",
  "block.minecraft.banner.square_top_right.white": "ສີ່ລ່ຽມຂວາເທິງສີຂາວ",
  "block.minecraft.banner.square_top_right.yellow": "ສີ່ລ່ຽມຂວາເທິງສີເຫຼືອງ",
  "block.minecraft.banner.straight_cross.black": "ໝາຍບວກສີດຳ",
  "block.minecraft.banner.straight_cross.blue": "ໝາຍບວກສີຟ້າ",
  "block.minecraft.banner.straight_cross.brown": "ໝາຍບວກສີນ້ຳຕານ",
  "block.minecraft.banner.straight_cross.cyan": "ໝາຍບວກສີຟ້າໃສ",
  "block.minecraft.banner.straight_cross.gray": "ໝາຍບວກສີເທົາ",
  "block.minecraft.banner.straight_cross.green": "ໝາຍບວກສີຂຽວ",
  "block.minecraft.banner.straight_cross.light_blue": "ໝາຍບວກສີຟ້າອ່ອນ",
  "block.minecraft.banner.straight_cross.light_gray": "ໝາຍບວກສີເທົາອ່ອນ",
  "block.minecraft.banner.straight_cross.lime": "ໝາຍບວກສີຂຽວອ່ອນ",
  "block.minecraft.banner.straight_cross.magenta": "ໝາຍບວກສີມ້ວງແດງ",
  "block.minecraft.banner.straight_cross.orange": "ໝາຍບວກສີສົ້ມ",
  "block.minecraft.banner.straight_cross.pink": "ໝາຍບວກສີບົວ",
  "block.minecraft.banner.straight_cross.purple": "ໝາຍບວກສີມ້ວງ",
  "block.minecraft.banner.straight_cross.red": "ໝາຍບວກສີແດງ",
  "block.minecraft.banner.straight_cross.white": "ໝາຍບວກສີຂາວ",
  "block.minecraft.banner.straight_cross.yellow": "ໝາຍບວກສີເຫຼືອງ",
  "block.minecraft.banner.stripe_bottom.black": "ພື້ນສີດຳ",
  "block.minecraft.banner.stripe_bottom.blue": "ພື້ນສີຟ້າ",
  "block.minecraft.banner.stripe_bottom.brown": "ພື້ນສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_bottom.cyan": "ພື້ນສີຟ້າໃສ",
  "block.minecraft.banner.stripe_bottom.gray": "ພື້ນສີເທົາ",
  "block.minecraft.banner.stripe_bottom.green": "ພື້ນສີຂຽວ",
  "block.minecraft.banner.stripe_bottom.light_blue": "ພື້ນສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_bottom.light_gray": "ພື້ນສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_bottom.lime": "ພື້ນສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_bottom.magenta": "ພື້ນສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_bottom.orange": "ພື້ນສີສົ້ມ",
  "block.minecraft.banner.stripe_bottom.pink": "ພື້ນສີບົວ",
  "block.minecraft.banner.stripe_bottom.purple": "ພື້ນສີມ້ວງ",
  "block.minecraft.banner.stripe_bottom.red": "ພື້ນສີແດງ",
  "block.minecraft.banner.stripe_bottom.white": "ພື້ນສີຂາວ",
  "block.minecraft.banner.stripe_bottom.yellow": "ພື້ນສີເຫຼືອງ",
  "block.minecraft.banner.stripe_center.black": "ຂີດຊື່ກາງສີດຳ",
  "block.minecraft.banner.stripe_center.blue": "ຂີດຊື່ກາງສີຟ້າ",
  "block.minecraft.banner.stripe_center.brown": "ຂີດຊື່ກາງສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_center.cyan": "ຂີດຊື່ກາງສີຟ້າໃສ",
  "block.minecraft.banner.stripe_center.gray": "ຂີດຊື່ກາງສີເທົາ",
  "block.minecraft.banner.stripe_center.green": "ຂີດຊື່ກາງສີຂຽວ",
  "block.minecraft.banner.stripe_center.light_blue": "ຂີດຊື່ກາງສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_center.light_gray": "ຂີດຊື່ກາງສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_center.lime": "ຂີດຊື່ກາງສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_center.magenta": "ຂີດຊື່ກາງສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_center.orange": "ຂີດຊື່ກາງສີສົ້ມ",
  "block.minecraft.banner.stripe_center.pink": "ຂີດຊື່ກາງສີບົວ",
  "block.minecraft.banner.stripe_center.purple": "ຂີດຊື່ກາງສີມ້ວງ",
  "block.minecraft.banner.stripe_center.red": "ຂີດຊື່ກາງສີແດງ",
  "block.minecraft.banner.stripe_center.white": "ຂີດຊື່ກາງສີຂາວ",
  "block.minecraft.banner.stripe_center.yellow": "ຂີດຊື່ກາງສີເຫຼືອງ",
  "block.minecraft.banner.stripe_downleft.black": "ຂີດຂວາງມຸມຊ້າຍສີດຳ",
  "block.minecraft.banner.stripe_downleft.blue": "ຂີດຂວາງມຸມຊ້າຍສີຟ້າ",
  "block.minecraft.banner.stripe_downleft.brown": "ຂີດຂວາງມຸມຊ້າຍສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_downleft.cyan": "ຂີດຂວາງມຸມຊ້າຍສີຟ້າໃສ",
  "block.minecraft.banner.stripe_downleft.gray": "ຂີດຂວາງມຸມຊ້າຍສີເທົາ",
  "block.minecraft.banner.stripe_downleft.green": "ຂີດຂວາງມຸມຊ້າຍສີຂຽວ",
  "block.minecraft.banner.stripe_downleft.light_blue": "ຂີດຂວາງມຸມຊ້າຍສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_downleft.light_gray": "ຂີດຂວາງມຸມຊ້າຍສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_downleft.lime": "ຂີດຂວາງມຸມຊ້າຍສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_downleft.magenta": "ຂີດຂວາງມຸມຊ້າຍສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_downleft.orange": "ຂີດຂວາງມຸມຊ້າຍສີສົ້ມ",
  "block.minecraft.banner.stripe_downleft.pink": "ຂີດຂວາງມຸມຊ້າຍສີບົວ",
  "block.minecraft.banner.stripe_downleft.purple": "ຂີດຂວາງມຸມຊ້າຍສີມ້ວງ",
  "block.minecraft.banner.stripe_downleft.red": "ຂີດຂວາງມຸມຊ້າຍສີແດງ",
  "block.minecraft.banner.stripe_downleft.white": "ຂີດຂວາງມຸມຊ້າຍສີຂາວ",
  "block.minecraft.banner.stripe_downleft.yellow": "ຂີດຂວາງມຸມຊ້າຍສີເຫຼືອງ",
  "block.minecraft.banner.stripe_downright.black": "ຂີດຂວາງມຸມຂວາສີດຳ",
  "block.minecraft.banner.stripe_downright.blue": "ຂີດຂວາງມຸມຂວາສີຟ້າ",
  "block.minecraft.banner.stripe_downright.brown": "ຂີດຂວາງມຸມຂວາສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_downright.cyan": "ຂີດຂວາງມຸມຂວາສີຟ້າໃສ",
  "block.minecraft.banner.stripe_downright.gray": "ຂີດຂວາງມຸມຂວາສີເທົາ",
  "block.minecraft.banner.stripe_downright.green": "ຂີດຂວາງມຸມຂວາສີຂຽວ",
  "block.minecraft.banner.stripe_downright.light_blue": "ຂີດຂວາງມຸມຂວາສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_downright.light_gray": "ຂີດຂວາງມຸມຂວາສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_downright.lime": "ຂີດຂວາງມຸມຂວາສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_downright.magenta": "ຂີດຂວາງມຸມຂວາສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_downright.orange": "ຂີດຂວາງມຸມຂວາສີສົ້ມ",
  "block.minecraft.banner.stripe_downright.pink": "ຂີດຂວາງມຸມຂວາສີບົວ",
  "block.minecraft.banner.stripe_downright.purple": "ຂີດຂວາງມຸມຂວາສີມ້ວງ",
  "block.minecraft.banner.stripe_downright.red": "ຂີດຂວາງມຸມຂວາສີແດງ",
  "block.minecraft.banner.stripe_downright.white": "ຂີດຂວາງມຸມຂວາສີຂາວ",
  "block.minecraft.banner.stripe_downright.yellow": "ຂີດຂວາງມຸມຂວາສີເຫຼືອງ",
  "block.minecraft.banner.stripe_left.black": "ຂີດຊື່ຊ້າຍສີດຳ",
  "block.minecraft.banner.stripe_left.blue": "ຂີດຊື່ຊ້າຍສີຟ້າ",
  "block.minecraft.banner.stripe_left.brown": "ຂີດຊື່ຊ້າຍສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_left.cyan": "ຂີດຊື່ຊ້າຍສີຟ້າໃສ",
  "block.minecraft.banner.stripe_left.gray": "ຂີດຊື່ຊ້າຍສີເທົາ",
  "block.minecraft.banner.stripe_left.green": "ຂີດຊື່ຊ້າຍສີຂຽວ",
  "block.minecraft.banner.stripe_left.light_blue": "ຂີດຊື່ຊ້າຍສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_left.light_gray": "ຂີດຊື່ຊ້າຍສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_left.lime": "ຂີດຊື່ຊ້າຍສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_left.magenta": "ຂີດຊື່ຊ້າຍສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_left.orange": "ຂີດຊື່ຊ້າຍສີສົ້ມ",
  "block.minecraft.banner.stripe_left.pink": "ຂີດຊື່ຊ້າຍສີບົວ",
  "block.minecraft.banner.stripe_left.purple": "ຂີດຊື່ຊ້າຍສີມ້ວງ",
  "block.minecraft.banner.stripe_left.red": "ຂີດຊື່ຊ້າຍສີແດງ",
  "block.minecraft.banner.stripe_left.white": "ຂີດຊື່ຊ້າຍສີຂາວ",
  "block.minecraft.banner.stripe_left.yellow": "ຂີດຊື່ຊ້າຍສີເຫຼືອງ",
  "block.minecraft.banner.stripe_middle.black": "ຂີດຂວາງສີດຳ",
  "block.minecraft.banner.stripe_middle.blue": "ຂີດຂວາງສີຟ້າ",
  "block.minecraft.banner.stripe_middle.brown": "ຂີດຂວາງສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_middle.cyan": "ຂີດຂວາງສີຟ້າໃສ",
  "block.minecraft.banner.stripe_middle.gray": "ຂີດຂວາງສີເທົາ",
  "block.minecraft.banner.stripe_middle.green": "ຂີດຂວາງສີຂຽວ",
  "block.minecraft.banner.stripe_middle.light_blue": "ຂີດຂວາງສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_middle.light_gray": "ຂີດຂວາງສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_middle.lime": "ຂີດຂວາງສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_middle.magenta": "ຂີດຂວາງສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_middle.orange": "ຂີດຂວາງສີສົ້ມ",
  "block.minecraft.banner.stripe_middle.pink": "ຂີດຂວາງສີບົວ",
  "block.minecraft.banner.stripe_middle.purple": "ຂີດຂວາງສີມ້ວງ",
  "block.minecraft.banner.stripe_middle.red": "ຂີດຂວາງສີແດງ",
  "block.minecraft.banner.stripe_middle.white": "ຂີດຂວາງສີຂາວ",
  "block.minecraft.banner.stripe_middle.yellow": "ຂີດຂວາງສີເຫຼືອງ",
  "block.minecraft.banner.stripe_right.black": "ຂີດຊື່ຂວາສີດຳ",
  "block.minecraft.banner.stripe_right.blue": "ຂີດຊື່ຂວາສີຟ້າ",
  "block.minecraft.banner.stripe_right.brown": "ຂີດຊື່ຂວາສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_right.cyan": "ຂີດຊື່ຂວາສີຟ້າໃສ",
  "block.minecraft.banner.stripe_right.gray": "ຂີດຊື່ຂວາສີເທົາ",
  "block.minecraft.banner.stripe_right.green": "ຂີດຊື່ຂວາສີຂຽວ",
  "block.minecraft.banner.stripe_right.light_blue": "ຂີດຊື່ຂວາສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_right.light_gray": "ຂີດຊື່ຂວາສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_right.lime": "ຂີດຊື່ຂວາສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_right.magenta": "ຂີດຊື່ຂວາສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_right.orange": "ຂີດຊື່ຂວາສີສົ້ມ",
  "block.minecraft.banner.stripe_right.pink": "ຂີດຊື່ຂວາສີບົວ",
  "block.minecraft.banner.stripe_right.purple": "ຂີດຊື່ຂວາສີມ້ວງ",
  "block.minecraft.banner.stripe_right.red": "ຂີດຊື່ຂວາສີແດງ",
  "block.minecraft.banner.stripe_right.white": "ຂີດຊື່ຂວາສີຂາວ",
  "block.minecraft.banner.stripe_right.yellow": "ຂີດຊື່ຂວາສີເຫຼືອງ",
  "block.minecraft.banner.stripe_top.black": "ຂີດຂວາງເທິງສີດຳ",
  "block.minecraft.banner.stripe_top.blue": "ຂີດຂວາງເທິງສີຟ້າ",
  "block.minecraft.banner.stripe_top.brown": "ຂີດຂວາງເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.stripe_top.cyan": "ຂີດຂວາງເທິງສີຟ້າໃສ",
  "block.minecraft.banner.stripe_top.gray": "ຂີດຂວາງເທິງສີເທົາ",
  "block.minecraft.banner.stripe_top.green": "ຂີດຂວາງເທິງສີຂຽວ",
  "block.minecraft.banner.stripe_top.light_blue": "ຂີດຂວາງເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.stripe_top.light_gray": "ຂີດຂວາງເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.stripe_top.lime": "ຂີດຂວາງເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.stripe_top.magenta": "ຂີດຂວາງເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.stripe_top.orange": "ຂີດຂວາງເທິງສີສົ້ມ",
  "block.minecraft.banner.stripe_top.pink": "ຂີດຂວາງເທິງສີບົວ",
  "block.minecraft.banner.stripe_top.purple": "ຂີດຂວາງເທິງສີມ້ວງ",
  "block.minecraft.banner.stripe_top.red": "ຂີດຂວາງເທິງສີແດງ",
  "block.minecraft.banner.stripe_top.white": "ຂີດຂວາງເທິງສີຂາວ",
  "block.minecraft.banner.stripe_top.yellow": "ຂີດຂວາງເທິງສີເຫຼືອງ",
  "block.minecraft.banner.triangle_bottom.black": "ສາມລ່ຽມລຸ່ມສີດຳ",
  "block.minecraft.banner.triangle_bottom.blue": "ສາມລ່ຽມລຸ່ມສີຟ້າ",
  "block.minecraft.banner.triangle_bottom.brown": "ສາມລ່ຽມລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.triangle_bottom.cyan": "ສາມລ່ຽມລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.triangle_bottom.gray": "ສາມລ່ຽມລຸ່ມສີເທົາ",
  "block.minecraft.banner.triangle_bottom.green": "ສາມລ່ຽມລຸ່ມສີຂຽວ",
  "block.minecraft.banner.triangle_bottom.light_blue": "ສາມລ່ຽມລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.triangle_bottom.light_gray": "ສາມລ່ຽມລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.triangle_bottom.lime": "ສາມລ່ຽມລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.triangle_bottom.magenta": "ສາມລ່ຽມລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.triangle_bottom.orange": "ສາມລ່ຽມລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.triangle_bottom.pink": "ສາມລ່ຽມລຸ່ມສີບົວ",
  "block.minecraft.banner.triangle_bottom.purple": "ສາມລ່ຽມລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.triangle_bottom.red": "ສາມລ່ຽມລຸ່ມສີແດງ",
  "block.minecraft.banner.triangle_bottom.white": "ສາມລ່ຽມລຸ່ມສີຂາວ",
  "block.minecraft.banner.triangle_bottom.yellow": "ສາມລ່ຽມລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.triangle_top.black": "ສາມລ່ຽມເທິງສີດຳ",
  "block.minecraft.banner.triangle_top.blue": "ສາມລ່ຽມເທິງສີຟ້າ",
  "block.minecraft.banner.triangle_top.brown": "ສາມລ່ຽມເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.triangle_top.cyan": "ສາມລ່ຽມເທິງສີຟ້າໃສ",
  "block.minecraft.banner.triangle_top.gray": "ສາມລ່ຽມເທິງສີເທົາ",
  "block.minecraft.banner.triangle_top.green": "ສາມລ່ຽມເທິງສີຂຽວ",
  "block.minecraft.banner.triangle_top.light_blue": "ສາມລ່ຽມເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.triangle_top.light_gray": "ສາມລ່ຽມເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.triangle_top.lime": "ສາມລ່ຽມເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.triangle_top.magenta": "ສາມລ່ຽມເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.triangle_top.orange": "ສາມລ່ຽມເທິງສີສົ້ມ",
  "block.minecraft.banner.triangle_top.pink": "ສາມລ່ຽມເທິງສີບົວ",
  "block.minecraft.banner.triangle_top.purple": "ສາມລ່ຽມເທິງສີມ້ວງ",
  "block.minecraft.banner.triangle_top.red": "ສາມລ່ຽມເທິງສີແດງ",
  "block.minecraft.banner.triangle_top.white": "ສາມລ່ຽມເທິງສີຂາວ",
  "block.minecraft.banner.triangle_top.yellow": "ສາມລ່ຽມເທິງສີເຫຼືອງ",
  "block.minecraft.banner.triangles_bottom.black": "ແຂ້ວລຸ່ມສີດຳ",
  "block.minecraft.banner.triangles_bottom.blue": "ແຂ້ວລຸ່ມສີຟ້າ",
  "block.minecraft.banner.triangles_bottom.brown": "ແຂ້ວລຸ່ມສີນ້ຳຕານ",
  "block.minecraft.banner.triangles_bottom.cyan": "ແຂ້ວລຸ່ມສີຟ້າໃສ",
  "block.minecraft.banner.triangles_bottom.gray": "ແຂ້ວລຸ່ມສີເທົາ",
  "block.minecraft.banner.triangles_bottom.green": "ແຂ້ວລຸ່ມສີຂຽວ",
  "block.minecraft.banner.triangles_bottom.light_blue": "ແຂ້ວລຸ່ມສີຟ້າອ່ອນ",
  "block.minecraft.banner.triangles_bottom.light_gray": "ແຂ້ວລຸ່ມສີເທົາອ່ອນ",
  "block.minecraft.banner.triangles_bottom.lime": "ແຂ້ວລຸ່ມສີຂຽວອ່ອນ",
  "block.minecraft.banner.triangles_bottom.magenta": "ແຂ້ວລຸ່ມສີມ້ວງແດງ",
  "block.minecraft.banner.triangles_bottom.orange": "ແຂ້ວລຸ່ມສີສົ້ມ",
  "block.minecraft.banner.triangles_bottom.pink": "ແຂ້ວລຸ່ມສີບົວ",
  "block.minecraft.banner.triangles_bottom.purple": "ແຂ້ວລຸ່ມສີມ້ວງ",
  "block.minecraft.banner.triangles_bottom.red": "ແຂ້ວລຸ່ມສີແດງ",
  "block.minecraft.banner.triangles_bottom.white": "ແຂ້ວລຸ່ມສີຂາວ",
  "block.minecraft.banner.triangles_bottom.yellow": "ແຂ້ວລຸ່ມສີເຫຼືອງ",
  "block.minecraft.banner.triangles_top.black": "ແຂ້ວເທິງສີດຳ",
  "block.minecraft.banner.triangles_top.blue": "ແຂ້ວເທິງສີຟ້າ",
  "block.minecraft.banner.triangles_top.brown": "ແຂ້ວເທິງສີນ້ຳຕານ",
  "block.minecraft.banner.triangles_top.cyan": "ແຂ້ວເທິງສີຟ້າໃສ",
  "block.minecraft.banner.triangles_top.gray": "ແຂ້ວເທິງສີເທົາ",
  "block.minecraft.banner.triangles_top.green": "ແຂ້ວເທິງສີຂຽວ",
  "block.minecraft.banner.triangles_top.light_blue": "ແຂ້ວເທິງສີຟ້າອ່ອນ",
  "block.minecraft.banner.triangles_top.light_gray": "ແຂ້ວເທິງສີເທົາອ່ອນ",
  "block.minecraft.banner.triangles_top.lime": "ແຂ້ວເທິງສີຂຽວອ່ອນ",
  "block.minecraft.banner.triangles_top.magenta": "ແຂ້ວເທິງສີມ້ວງແດງ",
  "block.minecraft.banner.triangles_top.orange": "ແຂ້ວເທິງສີສົ້ມ",
  "block.minecraft.banner.triangles_top.pink": "ແຂ້ວເທິງສີບົວ",
  "block.minecraft.banner.triangles_top.purple": "ແຂ້ວເທິງສີມ້ວງ",
  "block.minecraft.banner.triangles_top.red": "ແຂ້ວເທິງສີແດງ",
  "block.minecraft.banner.triangles_top.white": "ແຂ້ວເທິງສີຂາວ",
  "block.minecraft.banner.triangles_top.yellow": "ແຂ້ວເທິງສີເຫຼືອງ",
  "block.minecraft.barrel": "ຖັງໄມ້",
  "block.minecraft.barrier": "ບາຣ໌ເຣຍ",
  "block.minecraft.basalt": "ຫີນບະຊໍ",
  "block.minecraft.beacon": "ກະໂຈມໄຟ",
  "block.minecraft.beacon.primary": "ພະລັງງານຫຼັກ",
  "block.minecraft.beacon.secondary": "ພະລັງງານຮອງ",
  "block.minecraft.bed.no_sleep": "ເຈົ້າສາມາດນອນໄດ້ສະເພາະເວລາກາງຄືນ ຫຼື ຊ່ວງພາຍຸຝົນຟ້າຄະນອງ",
  "block.minecraft.bed.not_safe": "ເຈົ້າຍັງບໍ່ສາມາດນອນໄດ້; ເພາະມີສັດປະຫຼາດຢູ່ໃກ້ໆ",
  "block.minecraft.bed.obstructed": "ຕຽງຖືກນີ້ຖືກກີດຂວາງ",
  "block.minecraft.bed.occupied": "ຕຽງນີ້ຖືກຍຶດຄອງຢູ່",
  "block.minecraft.bed.too_far_away": "ເຈົ້າຍັງບໍ່ສາມາດນອນໄດ້; ເພາະຕຽງຢູ່ຫ່າງເກີນໄປ",
  "block.minecraft.bedrock": "ຫີນດານ",
  "block.minecraft.bee_nest": "ຮັງເຜິ້ງ",
  "block.minecraft.beehive": "ກ່ອງຮັງເຜິ້ງ",
  "block.minecraft.beetroots": "ບີດຣູດ",
  "block.minecraft.bell": "ລະຄັງ",
  "block.minecraft.big_dripleaf": "ໃບຍ້ອຍໃຫຍ່",
  "block.minecraft.big_dripleaf_stem": "ລຳຕົ້ນໃບຍ້ອຍໃຫຍ່",
  "block.minecraft.birch_button": "ປຸ່ມໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_door": "ປະຕູໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_fence": "ຮົ້ວໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_fence_gate": "ປະຕູຮົ້ວໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_leaves": "ໃບໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_log": "ຂອນໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_planks": "ແປ້ນໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_pressure_plate": "ແປ້ນຢຽບໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_sapling": "ເບ້ຍໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "ປ້າຍໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_slab": "ແຜ່ນໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_stairs": "ຄັນໄດໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_trapdoor": "ປະຕູກັບດັກໄມ້ຢືນຕົ້ນ",
  "block.minecraft.birch_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ຢືນຕົ້ນຕິດຝາ",
  "block.minecraft.birch_wall_sign": "ປ້າຍໄມ້ຢືນຕົ້ນຕິດຝາ",
  "block.minecraft.birch_wood": "ໄມ້ຢືນຕົ້ນ",
  "block.minecraft.black_banner": "ທຸງສີດຳ",
  "block.minecraft.black_bed": "ຕຽງສີດຳ",
  "block.minecraft.black_candle": "ທຽນສີດຳ",
  "block.minecraft.black_candle_cake": "ເຄັກພ້ອມທຽນສີດຳ",
  "block.minecraft.black_carpet": "ພົມສີດຳ",
  "block.minecraft.black_concrete": "ຄອນກຣີດສີດຳ",
  "block.minecraft.black_concrete_powder": "ຜົງຄອນກຣີດສີດຳ",
  "block.minecraft.black_glazed_terracotta": "ດິນເຜົາເຄືອບສີດຳ",
  "block.minecraft.black_shulker_box": "ກ່ອງເຊົາເກີສີດຳ",
  "block.minecraft.black_stained_glass": "ແວ່ນດ່າງສີດຳ",
  "block.minecraft.black_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີດຳ",
  "block.minecraft.black_terracotta": "ດິນເຜົາສີດຳ",
  "block.minecraft.black_wool": "ຂົນແກະສີດຳ",
  "block.minecraft.blackstone": "ຫີນດຳ",
  "block.minecraft.blackstone_slab": "ແຜ່ນຫີນດຳ",
  "block.minecraft.blackstone_stairs": "ຄັນໄດຫີນດຳ",
  "block.minecraft.blackstone_wall": "ກຳແພງຫີນດຳ",
  "block.minecraft.blast_furnace": "ເຕົາຫຼອມ",
  "block.minecraft.blue_banner": "ທຸງສີຟ້າ",
  "block.minecraft.blue_bed": "ຕຽງສີຟ້າ",
  "block.minecraft.blue_candle": "ທຽນສີຟ້າ",
  "block.minecraft.blue_candle_cake": "ເຄັກພ້ອມທຽນສີຟ້າ",
  "block.minecraft.blue_carpet": "ພົມສີຟ້າ",
  "block.minecraft.blue_concrete": "ຄອນກຣີດສີຟ້າ",
  "block.minecraft.blue_concrete_powder": "ຜົງຄອນກຣີດສີຟ້າ",
  "block.minecraft.blue_glazed_terracotta": "ດິນເຜົາເຄືອບສີຟ້າ",
  "block.minecraft.blue_ice": "ນ້ຳກ້ອນຟ້າ",
  "block.minecraft.blue_orchid": "ດອກເອື້ອງຟ້າ",
  "block.minecraft.blue_shulker_box": "ກ່ອງເຊົາເກີສີຟ້າ",
  "block.minecraft.blue_stained_glass": "ແວ່ນດ່າງສີຟ້າ",
  "block.minecraft.blue_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຟ້າ",
  "block.minecraft.blue_terracotta": "ດິນເຜົາສີຟ້າ",
  "block.minecraft.blue_wool": "ຂົນແກະສີຟ້າ",
  "block.minecraft.bone_block": "ບລ໋ອກກະດູກ",
  "block.minecraft.bookshelf": "ຊັ້ນວາງປຶ້ມ",
  "block.minecraft.brain_coral": "ປະກາລັງສະໝອງ",
  "block.minecraft.brain_coral_block": "ບລ໋ອກປະກາລັງສະໝອງ",
  "block.minecraft.brain_coral_fan": "ປະກາລັງສະໝອງຮູບວີ",
  "block.minecraft.brain_coral_wall_fan": "ປະກາລັງສະໝອງຮູບວີຕິດຝາ",
  "block.minecraft.brewing_stand": "ແທ່ນປຸງຢາ",
  "block.minecraft.brick_slab": "ແຜ່ນດິນຈີ່",
  "block.minecraft.brick_stairs": "ຄັນໄດດິນຈີ່",
  "block.minecraft.brick_wall": "ກຳແພງດິນຈີ່",
  "block.minecraft.bricks": "ດິນຈີ່",
  "block.minecraft.brown_banner": "ທຸງສີນ້ຳຕານ",
  "block.minecraft.brown_bed": "ຕຽງສີນ້ຳຕານ",
  "block.minecraft.brown_candle": "ທຽນສີນ້ຳຕານ",
  "block.minecraft.brown_candle_cake": "ເຄັກພ້ອມທຽນສີນ້ຳຕານ",
  "block.minecraft.brown_carpet": "ພົມສີນ້ຳຕານ",
  "block.minecraft.brown_concrete": "ຄອນກຣີດສີນ້ຳຕານ",
  "block.minecraft.brown_concrete_powder": "ຜົງຄອນກຣີດສີນ້ຳຕານ",
  "block.minecraft.brown_glazed_terracotta": "ດິນເຜົາເຄືອບສີນ້ຳຕານ",
  "block.minecraft.brown_mushroom": "ເຫັດສີນ້ຳຕານ",
  "block.minecraft.brown_mushroom_block": "ບລ໋ອກເຫັດສີນ້ຳຕານ",
  "block.minecraft.brown_shulker_box": "ກ່ອງເຊົາເກີສີນ້ຳຕານ",
  "block.minecraft.brown_stained_glass": "ແວ່ນດ່າງສີນ້ຳຕານ",
  "block.minecraft.brown_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີນ້ຳຕານ",
  "block.minecraft.brown_terracotta": "ດິນເຜົາສີນ້ຳຕານ",
  "block.minecraft.brown_wool": "ຂົນແກະສີນ້ຳຕານ",
  "block.minecraft.bubble_column": "ຟອງແນວຕັ້ງ",
  "block.minecraft.bubble_coral": "ປະກາລັງຟອງ",
  "block.minecraft.bubble_coral_block": "ບລ໋ອກປະກາລັງຟອງ",
  "block.minecraft.bubble_coral_fan": "ປະກາລັງຟອງຮູບວີ",
  "block.minecraft.bubble_coral_wall_fan": "ປະກາລັງຟອງຮູບວີຕິດຝາ",
  "block.minecraft.budding_amethyst": "ຕົ້ນໜໍ່ອາເມທິສ",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "ຕົ້ນກະບອງເພັດ",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "ເຄັກ",
  "block.minecraft.calcite": "ແຮ່ແຄວໄຊທ໌",
  "block.minecraft.calibrated_sculk_sensor": "ສະເກົາກວດຈັບແຮງສັ່ນ",
  "block.minecraft.campfire": "ແຄັມໄຟ",
  "block.minecraft.candle": "ທຽນ",
  "block.minecraft.candle_cake": "ເຄັກພ້ອມທຽນ",
  "block.minecraft.carrots": "ກະຫຼົດ",
  "block.minecraft.cartography_table": "ໂຕະເຮັດແຜນທີ່",
  "block.minecraft.carved_pumpkin": "ໝາກອຶແກະສະຫຼັກ",
  "block.minecraft.cauldron": "ໝໍ້ປຸງຢາ",
  "block.minecraft.cave_air": "ອາກາດຖ້ຳ",
  "block.minecraft.cave_vines": "ເຄືອຖ້ຳ",
  "block.minecraft.cave_vines_plant": "ຕົ້ນເຄືອຖ້ຳ",
  "block.minecraft.chain": "ໂສ້",
  "block.minecraft.chain_command_block": "ບລ໋ອກຄຳສັ່ງແບບໂສ້",
  "block.minecraft.cherry_button": "ປຸ່ມໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_door": "ປະຕູໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_fence": "ຮົ້ວໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_fence_gate": "ປະຕູຮົ້ວໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_leaves": "ໃບໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_log": "ຂອນໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_planks": "ແປ້ນໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_pressure_plate": "ແປ້ນຢຽບໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_sapling": "ເບ້ຍຊາກຸຣະ",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "ປ້າຍໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_slab": "ແຜ່ນໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_stairs": "ຄັນໄດໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_trapdoor": "ປະຕູກັບດັກໄມ້ຊາກຸຣະ",
  "block.minecraft.cherry_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ຊາກຸຣະຕິດຝາ",
  "block.minecraft.cherry_wall_sign": "ປ້າຍໄມ້ຊາກຸຣະຕິດຝາ",
  "block.minecraft.cherry_wood": "ໄມ້ຊາກຸຣະ",
  "block.minecraft.chest": "ຫີບ",
  "block.minecraft.chipped_anvil": "ທັ່ງບິ່ນ",
  "block.minecraft.chiseled_bookshelf": "ຊັ້ນວາງປຶ້ມແກະສະຫຼັກ",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "ຫີນຊະນວນເລິກສະຫຼັກ",
  "block.minecraft.chiseled_nether_bricks": "ດິນຈີ່ເນເທີສະຫຼັກ",
  "block.minecraft.chiseled_polished_blackstone": "ຫີນດຳຂັດສະຫຼັກ",
  "block.minecraft.chiseled_quartz_block": "ບລ໋ອກມະນີສິລາສະຫຼັກ",
  "block.minecraft.chiseled_red_sandstone": "ຫີນຊາຍແດງສະຫຼັກ",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "ຫີນຊາຍສະຫຼັກ",
  "block.minecraft.chiseled_stone_bricks": "ດິນຈີ່ຫີນສະຫຼັກ",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "ດອກຄໍຣັສ",
  "block.minecraft.chorus_plant": "ຕົ້ນຄໍຣັສ",
  "block.minecraft.clay": "ດິນດາກ",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "ບລ໋ອກຖ່ານຫີນ",
  "block.minecraft.coal_ore": "ແຮ່ຖ່ານຫີນ",
  "block.minecraft.coarse_dirt": "ດິນຫຍາບ",
  "block.minecraft.cobbled_deepslate": "ຫີນຊະນວນເລິກຫຍາບ",
  "block.minecraft.cobbled_deepslate_slab": "ແຜ່ນຫີນຊະນວນເລິກຫຍາບ",
  "block.minecraft.cobbled_deepslate_stairs": "ຄັນໄດຫີນຊະນວນເລິກຫຍາບ",
  "block.minecraft.cobbled_deepslate_wall": "ກຳແພງຫີນຊະນວນເລິກຫຍາບ",
  "block.minecraft.cobblestone": "ຫີນຫຍາບ",
  "block.minecraft.cobblestone_slab": "ແຜ່ນຫີນຫຍາບ",
  "block.minecraft.cobblestone_stairs": "ຄັນໄດຫີນຫຍາບ",
  "block.minecraft.cobblestone_wall": "ກຳແພງຫີນຫຍາບ",
  "block.minecraft.cobweb": "ໃຍແມງມຸມ",
  "block.minecraft.cocoa": "ໂກໂກ້",
  "block.minecraft.command_block": "ບລ໋ອກຄຳສັ່ງ",
  "block.minecraft.comparator": "ໂຕປຽບທຽບຫີນແດງ",
  "block.minecraft.composter": "ລັງໝັກປຸຍ",
  "block.minecraft.conduit": "ໄຟສິລາ",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "ບລ໋ອກທອງແດງ",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "ແຮ່ທອງແດງ",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "ຄອຣ໌ນຟລາວເວີ",
  "block.minecraft.cracked_deepslate_bricks": "ດິນຈີ່ຫີນຊະນວນເລິກແຕກ",
  "block.minecraft.cracked_deepslate_tiles": "ກະໂລ້ຫີນຊະນວນເລິກແຕກ",
  "block.minecraft.cracked_nether_bricks": "ດິນຈີ່ເນເທີແຕກ",
  "block.minecraft.cracked_polished_blackstone_bricks": "ດິນຈີ່ຫີນດຳຂັດແຕກ",
  "block.minecraft.cracked_stone_bricks": "ດິນຈີ່ຫີນແຕກ",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "ໂຕະຄຣາບ",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "ຫົວຄຣີບເປີ",
  "block.minecraft.creeper_wall_head": "ຫົວຄຣີບເປີຕິດຝາ",
  "block.minecraft.crimson_button": "ປຸ່ມໄມ້ສີເລືອດ",
  "block.minecraft.crimson_door": "ປະຕູໄມ້ສີເລືອດ",
  "block.minecraft.crimson_fence": "ຮົ້ວໄມ້ສີເລືອດ",
  "block.minecraft.crimson_fence_gate": "ປະຕູຮົ້ວໄມ້ສີເລືອດ",
  "block.minecraft.crimson_fungus": "ເຫັດເຊື້ອລາສີເລືອດ",
  "block.minecraft.crimson_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ສີເລືອດ",
  "block.minecraft.crimson_hyphae": "ໄຮແພສີເລືອດ",
  "block.minecraft.crimson_nylium": "ນີລ້ຽມສີເລືອດ",
  "block.minecraft.crimson_planks": "ແປ້ນໄມ້ສີເລືອດ",
  "block.minecraft.crimson_pressure_plate": "ແປ້ນຢຽບໄມ້ສີເລືອດ",
  "block.minecraft.crimson_roots": "ຮາກໄມ້ສີເລືອດ",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "ປ້າຍໄມ້ສີເລືອດ",
  "block.minecraft.crimson_slab": "ແຜ່ນໄມ້ສີເລືອດ",
  "block.minecraft.crimson_stairs": "ຄັນໄດໄມ້ສີເລືອດ",
  "block.minecraft.crimson_stem": "ລຳຕົ້ນໄມ້ສີເລືອດ",
  "block.minecraft.crimson_trapdoor": "ປະຕູກັບດັກໄມ້ສີເລືອດ",
  "block.minecraft.crimson_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ສີເລືອດຕິດຝາ",
  "block.minecraft.crimson_wall_sign": "ປ້າຍໄມ້ສີເລືອດຕິດຝາ",
  "block.minecraft.crying_obsidian": "ຫີນອ໋ອບຊິດ້ຽນຮ້ອງໄຫ້",
  "block.minecraft.cut_copper": "ທອງແດງຕັດ",
  "block.minecraft.cut_copper_slab": "ແຜ່ນທອງແດງຕັດ",
  "block.minecraft.cut_copper_stairs": "ຄັນໄດທອງແດງຕັດ",
  "block.minecraft.cut_red_sandstone": "ຫີນຊາຍແດງຕັດ",
  "block.minecraft.cut_red_sandstone_slab": "ແຜ່ນຫີນຊາຍແດງຕັດ",
  "block.minecraft.cut_sandstone": "ຫີນຊາຍຕັດ",
  "block.minecraft.cut_sandstone_slab": "ແຜ່ນຫີນຊາຍຕັດ",
  "block.minecraft.cyan_banner": "ທຸງສີຟ້າໃສ",
  "block.minecraft.cyan_bed": "ຕຽງສີຟ້າໃສ",
  "block.minecraft.cyan_candle": "ທຽນສີຟ້າໃສ",
  "block.minecraft.cyan_candle_cake": "ເຄັກພ້ອມທຽນສີຟ້າໃສ",
  "block.minecraft.cyan_carpet": "ພົມສີຟ້າໃສ",
  "block.minecraft.cyan_concrete": "ຄອນກຣີດສີຟ້າໃສ",
  "block.minecraft.cyan_concrete_powder": "ຜົງຄອນກຣີດສີຟ້າໃສ",
  "block.minecraft.cyan_glazed_terracotta": "ດິນເຜົາເຄືອບສີຟ້າໃສ",
  "block.minecraft.cyan_shulker_box": "ກ່ອງເຊົາເກີສີຟ້າໃສ",
  "block.minecraft.cyan_stained_glass": "ແວ່ນດ່າງສີຟ້າໃສ",
  "block.minecraft.cyan_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຟ້າໃສ",
  "block.minecraft.cyan_terracotta": "ດິນເຜົາສີຟ້າໃສ",
  "block.minecraft.cyan_wool": "ຂົນແກະສີຟ້າໃສ",
  "block.minecraft.damaged_anvil": "ທັ່ງເສຍຫາຍ",
  "block.minecraft.dandelion": "ດອກແດນດິໄລອອນ",
  "block.minecraft.dark_oak_button": "ປຸ່ມໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_door": "ປະຕູໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_fence": "ຮົ້ວໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_fence_gate": "ປະຕູຮົ້ວໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_leaves": "ໃບໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_log": "ຂອນໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_planks": "ແປ້ນໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_pressure_plate": "ແປ້ນຢຽບໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_sapling": "ເບ້ຍໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "ປ້າຍໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_slab": "ແຜ່ນໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_stairs": "ຄັນໄດໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_trapdoor": "ປະຕູກັບດັກໄມ້ໂອກດຳ",
  "block.minecraft.dark_oak_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂອກດຳຕິດຝາ",
  "block.minecraft.dark_oak_wall_sign": "ປ້າຍໄມ້ໂອກດຳຕິດຝາ",
  "block.minecraft.dark_oak_wood": "ໄມ້ໂອກດຳ",
  "block.minecraft.dark_prismarine": "ພຣິສມາຣີນເຂັ້ມ",
  "block.minecraft.dark_prismarine_slab": "ແຜ່ນພຣິສມາຣີນເຂັ້ມ",
  "block.minecraft.dark_prismarine_stairs": "ຄັນໄດພຣິສມາຣີນເຂັ້ມ",
  "block.minecraft.daylight_detector": "ເຄື່ອງກວດຈັບແສງແດດ",
  "block.minecraft.dead_brain_coral": "ປະກາລັງສະໝອງຕາຍ",
  "block.minecraft.dead_brain_coral_block": "ບລ໋ອກປະກາລັງສະໝອງຕາຍ",
  "block.minecraft.dead_brain_coral_fan": "ປະກາລັງສະໝອງຕາຍຮູບວີ",
  "block.minecraft.dead_brain_coral_wall_fan": "ປະກາລັງສະໝອງຕາຍຮູບວີຕິດຝາ",
  "block.minecraft.dead_bubble_coral": "ປະກາລັງຟອງຕາຍ",
  "block.minecraft.dead_bubble_coral_block": "ບລ໋ອກປະກາລັງຟອງຕາຍ",
  "block.minecraft.dead_bubble_coral_fan": "ປະກາລັງຟອງຕາຍຮູບວີ",
  "block.minecraft.dead_bubble_coral_wall_fan": "ປະກາລັງຟອງຕາຍຮູບວີຕິດຝາ",
  "block.minecraft.dead_bush": "ຟຸ່ມໄມ້ແຫ້ງ",
  "block.minecraft.dead_fire_coral": "ປະກາລັງໄຟຕາຍ",
  "block.minecraft.dead_fire_coral_block": "ບລ໋ອກປະກາລັງໄຟຕາຍ",
  "block.minecraft.dead_fire_coral_fan": "ປະກາລັງໄຟຕາຍຮູບວີ",
  "block.minecraft.dead_fire_coral_wall_fan": "ປະກາລັງໄຟຕາຍຮູບວີຕິດຝາ",
  "block.minecraft.dead_horn_coral": "ປະກາລັງເຂົາຕາຍ",
  "block.minecraft.dead_horn_coral_block": "ບລ໋ອກປະກາລັງເຂົາຕາຍ",
  "block.minecraft.dead_horn_coral_fan": "ປະກາລັງເຂົາຕາຍຮູບວີ",
  "block.minecraft.dead_horn_coral_wall_fan": "ປະກາລັງເຂົາຕາຍຮູບວີຕິດຝາ",
  "block.minecraft.dead_tube_coral": "ປະກາລັງຫຼອດຕາຍ",
  "block.minecraft.dead_tube_coral_block": "ບລ໋ອກປະກາລັງຫຼອດຕາຍ",
  "block.minecraft.dead_tube_coral_fan": "ປະກາລັງຫຼອດຕາຍຮູບວີ",
  "block.minecraft.dead_tube_coral_wall_fan": "ປະກາລັງຫຼອດຕາຍຮູບວີຕິດຝາ",
  "block.minecraft.decorated_pot": "ໂຖຕົບແຕ່ງ",
  "block.minecraft.deepslate": "ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_brick_slab": "ແຜ່ນດິນຈີ່ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_brick_stairs": "ຄັນໄດດິນຈີ່ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_brick_wall": "ກຳແພງດິນຈີ່ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_bricks": "ດິນຈີ່ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_coal_ore": "ແຮ່ຖ່ານຫີນໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_copper_ore": "ແຮ່ທອງແດງໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_diamond_ore": "ແຮ່ເພັດໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_emerald_ore": "ແຮ່ມໍລະກົດໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_gold_ore": "ແຮ່ຄຳໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_iron_ore": "ແຮ່ເຫຼັກໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_lapis_ore": "ແຮ່ເພທູນໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_redstone_ore": "ແຮ່ຫີນແດງໃນຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_tile_slab": "ແຜ່ນກະໂລ້ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_tile_stairs": "ຄັນໄດກະໂລ້ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_tile_wall": "ກຳແພງກະໂລ້ຫີນຊະນວນເລິກ",
  "block.minecraft.deepslate_tiles": "ກະໂລ້ຫີນຊະນວນເລິກ",
  "block.minecraft.detector_rail": "ລາງກວດຈັບ",
  "block.minecraft.diamond_block": "ບລ໋ອກເພັດ",
  "block.minecraft.diamond_ore": "ແຮ່ເພັດ",
  "block.minecraft.diorite": "ຫີນໄດອໍໄຣທ໌",
  "block.minecraft.diorite_slab": "ແຜ່ນຫີນໄດອໍໄຣທ໌",
  "block.minecraft.diorite_stairs": "ຄັນໄດຫີນໄດອໍໄຣທ໌",
  "block.minecraft.diorite_wall": "ກຳແພງຫີນໄດອໍໄຣທ໌",
  "block.minecraft.dirt": "ດິນ",
  "block.minecraft.dirt_path": "ທາງດິນ",
  "block.minecraft.dispenser": "ເຄື່ອງຍິງ",
  "block.minecraft.dragon_egg": "ໄຂ່ມັງກອນ",
  "block.minecraft.dragon_head": "ຫົວມັງກອນ",
  "block.minecraft.dragon_wall_head": "ຫົວມັງກອນຕິດຝາ",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "ບລ໋ອກສາຫຼ່າຍທະເລແຫ້ງ",
  "block.minecraft.dripstone_block": "ບລ໋ອກຫີນຍ້ອຍ",
  "block.minecraft.dropper": "ເຄື່ອງດຣ໋ອບ",
  "block.minecraft.emerald_block": "ບລ໋ອກມໍລະກົດ",
  "block.minecraft.emerald_ore": "ແຮ່ມໍລະກົດ",
  "block.minecraft.enchanting_table": "ໂຕະຮວາຍມົນ",
  "block.minecraft.end_gateway": "ປະຕູທາງຜ່ານເອັນ",
  "block.minecraft.end_portal": "ປະຕູມິຕິເອັນ",
  "block.minecraft.end_portal_frame": "ຂອບປະຕູມິຕິເອັນ",
  "block.minecraft.end_rod": "ແທ່ງເອັນ",
  "block.minecraft.end_stone": "ຫີນເອັນ",
  "block.minecraft.end_stone_brick_slab": "ແຜ່ນດິນຈີ່ຫີນເອັນ",
  "block.minecraft.end_stone_brick_stairs": "ຄັນໄດດິນຈີ່ຫີນເອັນ",
  "block.minecraft.end_stone_brick_wall": "ກຳແພງດິນຈີ່ຫີນເອັນ",
  "block.minecraft.end_stone_bricks": "ດິນຈີ່ຫີນເອັນ",
  "block.minecraft.ender_chest": "ຫີບເອັນເດີ",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "ທອງແດງລອກ",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "ທອງແດງຕັດລອກ",
  "block.minecraft.exposed_cut_copper_slab": "ແຜ່ນທອງແດງຕັດລອກ",
  "block.minecraft.exposed_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດລອກ",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "ຂຸມເຮັດຟາຣ໌ມ",
  "block.minecraft.fern": "ຜັກກູດ",
  "block.minecraft.fire": "ໄຟ",
  "block.minecraft.fire_coral": "ປະກາລັງໄຟ",
  "block.minecraft.fire_coral_block": "ບລ໋ອກປະກາລັງໄຟ",
  "block.minecraft.fire_coral_fan": "ປະກາລັງໄຟຮູບວີ",
  "block.minecraft.fire_coral_wall_fan": "ປະກາລັງໄຟຮູບວີຕິດຝາ",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "ໂຕະເຮັດທະນູ",
  "block.minecraft.flower_pot": "ໂຖດອກໄມ້",
  "block.minecraft.flowering_azalea": "ກຸຫຼາບພັນປີມີດອກ",
  "block.minecraft.flowering_azalea_leaves": "ໃບກຸຫຼາບພັນປີມີດອກ",
  "block.minecraft.frogspawn": "ໄຂ່ກົບ",
  "block.minecraft.frosted_ice": "ນ້ຳກ້ອນໂຄດເຢັນ",
  "block.minecraft.furnace": "ເຕົາເຜົາ",
  "block.minecraft.gilded_blackstone": "ຫີນດຳຝັງຄຳ",
  "block.minecraft.glass": "ແວ່ນ",
  "block.minecraft.glass_pane": "ແຜ່ນແວ່ນ",
  "block.minecraft.glow_lichen": "ໄລເຄນເຮືອງແສງ",
  "block.minecraft.glowstone": "ຫີນເຮືອງແສງ",
  "block.minecraft.gold_block": "ບລ໋ອກຄຳ",
  "block.minecraft.gold_ore": "ແຮ່ຄຳ",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "ຫີນແກຣນິດ",
  "block.minecraft.granite_slab": "ແຜ່ນຫີນແກຣນິດ",
  "block.minecraft.granite_stairs": "ຄັນໄດຫີນແກຣນິດ",
  "block.minecraft.granite_wall": "ກຳແພງຫີນແກຣນິດ",
  "block.minecraft.grass": "ຫຍ້າ",
  "block.minecraft.grass_block": "ບລ໋ອກຫຍ້າ",
  "block.minecraft.gravel": "ຫີນແຮ່",
  "block.minecraft.gray_banner": "ທຸງສີເທົາ",
  "block.minecraft.gray_bed": "ຕຽງສີເທົາ",
  "block.minecraft.gray_candle": "ທຽນສີເທົາ",
  "block.minecraft.gray_candle_cake": "ເຄັກພ້ອມທຽນສີເທົາ",
  "block.minecraft.gray_carpet": "ພົມສີເທົາ",
  "block.minecraft.gray_concrete": "ຄອນກຣີດສີເທົາ",
  "block.minecraft.gray_concrete_powder": "ຜົງຄອນກຣີດສີເທົາ",
  "block.minecraft.gray_glazed_terracotta": "ດິນເຜົາເຄືອບສີເທົາ",
  "block.minecraft.gray_shulker_box": "ກ່ອງເຊົາເກີສີເທົາ",
  "block.minecraft.gray_stained_glass": "ແວ່ນດ່າງສີເທົາ",
  "block.minecraft.gray_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີເທົາ",
  "block.minecraft.gray_terracotta": "ດິນເຜົາສີເທົາ",
  "block.minecraft.gray_wool": "ຂົນແກະສີເທົາ",
  "block.minecraft.green_banner": "ທຸງສີຂຽວ",
  "block.minecraft.green_bed": "ຕຽງສີຂຽວ",
  "block.minecraft.green_candle": "ທຽນສີຂຽວ",
  "block.minecraft.green_candle_cake": "ເຄັກພ້ອມທຽນສີຂຽວ",
  "block.minecraft.green_carpet": "ພົມສີຂຽວ",
  "block.minecraft.green_concrete": "ຄອນກຣີດສີຂຽວ",
  "block.minecraft.green_concrete_powder": "ຜົງຄອນກຣີດສີຂຽວ",
  "block.minecraft.green_glazed_terracotta": "ດິນເຜົາເຄືອບສີຂຽວ",
  "block.minecraft.green_shulker_box": "ກ່ອງເຊົາເກີສີຂຽວ",
  "block.minecraft.green_stained_glass": "ແວ່ນດ່າງສີຂຽວ",
  "block.minecraft.green_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຂຽວ",
  "block.minecraft.green_terracotta": "ດິນເຜົາສີຂຽວ",
  "block.minecraft.green_wool": "ຂົນແກະສີຂຽວ",
  "block.minecraft.grindstone": "ຫີນໂມ້",
  "block.minecraft.hanging_roots": "ຮາກຫ້ອຍ",
  "block.minecraft.hay_block": "ກອງຟາງ",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "ແປ້ນຢຽບຖ່ວງນ້ຳໜັກໂຄດໜັກ",
  "block.minecraft.honey_block": "ບລ໋ອກນ້ຳເຜິ້ງ",
  "block.minecraft.honeycomb_block": "ບລ໋ອກຮວງເຜິ້ງ",
  "block.minecraft.hopper": "ທໍ່ສົ່ງ",
  "block.minecraft.horn_coral": "ປະກາລັງເຂົາ",
  "block.minecraft.horn_coral_block": "ບລ໋ອກປະກາລັງເຂົາ",
  "block.minecraft.horn_coral_fan": "ປະກາລັງເຂົາຮູບວີ",
  "block.minecraft.horn_coral_wall_fan": "ປະກາລັງເຂົາຮູບວີຕິດຝາ",
  "block.minecraft.ice": "ນ້ຳກ້ອນ",
  "block.minecraft.infested_chiseled_stone_bricks": "ດິນຈີ່ຫີນສະຫຼັກຕິດເຊື້ອ",
  "block.minecraft.infested_cobblestone": "ຫີນຫຍາບຕິດເຊື້ອ",
  "block.minecraft.infested_cracked_stone_bricks": "ດິນຈີ່ຫີນແຕກຕິດເຊື້ອ",
  "block.minecraft.infested_deepslate": "ຫີນຊະນວນເລິກຕິດເຊື້ອ",
  "block.minecraft.infested_mossy_stone_bricks": "ດິນຈີ່ຫີນຂີ້ໄຄຕິດເຊື້ອ",
  "block.minecraft.infested_stone": "ຫີນຕິດເຊື້ອ",
  "block.minecraft.infested_stone_bricks": "ດິນຈີ່ຫີນຕິດເຊື້ອ",
  "block.minecraft.iron_bars": "ກົງເຫຼັກ",
  "block.minecraft.iron_block": "ບລ໋ອກເຫຼັກ",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "ປະຕູເຫຼັກ",
  "block.minecraft.iron_ore": "ແຮ່ເຫຼັກ",
  "block.minecraft.iron_trapdoor": "ປະຕູກັບດັກເຫຼັກ",
  "block.minecraft.jack_o_lantern": "ໂຄມໄຟໝາກອຶ",
  "block.minecraft.jigsaw": "ບລ໋ອກຈິກຊໍ",
  "block.minecraft.jukebox": "ຕູ້ເພງ",
  "block.minecraft.jungle_button": "ປຸ່ມໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_door": "ປະຕູໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_fence": "ຮົ້ວໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_fence_gate": "ປະຕູຮົ້ວໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_leaves": "ໃບໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_log": "ຂອນໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_planks": "ແປ້ນໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_pressure_plate": "ແປ້ນຢຽບໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_sapling": "ເບ້ຍໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "ປ້າຍໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_slab": "ແຜ່ນໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_stairs": "ຄັນໄດໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_trapdoor": "ປະຕູກັບດັກໄມ້ປ່າດົງດິບ",
  "block.minecraft.jungle_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ປ່າດົງດິບຕິດຝາ",
  "block.minecraft.jungle_wall_sign": "ປ້າຍໄມ້ປ່າດົງດິບຕິດຝາ",
  "block.minecraft.jungle_wood": "ໄມ້ປ່າດົງດິບ",
  "block.minecraft.kelp": "ສາຫຼ່າຍທະເລ",
  "block.minecraft.kelp_plant": "ຕົ້ນສາຫຼ່າຍທະເລ",
  "block.minecraft.ladder": "ຄັນໄດລິງ",
  "block.minecraft.lantern": "ໂຄມໄຟ",
  "block.minecraft.lapis_block": "ບລ໋ອກເພທູນ",
  "block.minecraft.lapis_ore": "ແຮ່ເພທູນ",
  "block.minecraft.large_amethyst_bud": "ໜໍ່ອາເມທິສຂະໜາດໃຫຍ່",
  "block.minecraft.large_fern": "ຜັກກູດໃຫຍ່",
  "block.minecraft.lava": "ລາວາ",
  "block.minecraft.lava_cauldron": "ໝໍ້ປຸງຢາລາວາ",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "ແທ່ນອ່ານປຶ້ມ",
  "block.minecraft.lever": "ຄັນໂຍກ",
  "block.minecraft.light": "ບລ໋ອກແສງ",
  "block.minecraft.light_blue_banner": "ທຸງສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_bed": "ຕຽງສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_candle": "ທຽນສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_candle_cake": "ເຄັກພ້ອມທຽນສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_carpet": "ພົມສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_concrete": "ຄອນກຣີດສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_concrete_powder": "ຜົງຄອນກຣີດສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_glazed_terracotta": "ດິນເຜົາເຄືອບສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_shulker_box": "ກ່ອງເຊົາເກີສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_stained_glass": "ແວ່ນດ່າງສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_terracotta": "ດິນເຜົາສີຟ້າອ່ອນ",
  "block.minecraft.light_blue_wool": "ຂົນແກະສີຟ້າອ່ອນ",
  "block.minecraft.light_gray_banner": "ທຸງສີເທົາອ່ອນ",
  "block.minecraft.light_gray_bed": "ຕຽງສີເທົາອ່ອນ",
  "block.minecraft.light_gray_candle": "ທຽນສີເທົາອ່ອນ",
  "block.minecraft.light_gray_candle_cake": "ເຄັກພ້ອມທຽນສີເທົາອ່ອນ",
  "block.minecraft.light_gray_carpet": "ພົມສີເທົາອ່ອນ",
  "block.minecraft.light_gray_concrete": "ຄອນກຣີດສີເທົາອ່ອນ",
  "block.minecraft.light_gray_concrete_powder": "ຜົງຄອນກຣີດສີເທົາອ່ອນ",
  "block.minecraft.light_gray_glazed_terracotta": "ດິນເຜົາເຄືອບສີເທົາອ່ອນ",
  "block.minecraft.light_gray_shulker_box": "ກ່ອງເຊົາເກີສີເທົາອ່ອນ",
  "block.minecraft.light_gray_stained_glass": "ແວ່ນດ່າງສີເທົາອ່ອນ",
  "block.minecraft.light_gray_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີເທົາອ່ອນ",
  "block.minecraft.light_gray_terracotta": "ດິນເຜົາສີເທົາອ່ອນ",
  "block.minecraft.light_gray_wool": "ຂົນແກະສີເທົາອ່ອນ",
  "block.minecraft.light_weighted_pressure_plate": "ແປ້ນຢຽບຖ່ວງນ້ຳໜັກໂຄດເບົາ",
  "block.minecraft.lightning_rod": "ສາຍລໍ້ຟ້າ",
  "block.minecraft.lilac": "ດອກໄລແລັກ",
  "block.minecraft.lily_of_the_valley": "ລິນລີ່ແຫ່ງຮ່ອມພູ",
  "block.minecraft.lily_pad": "ໃບບົວ",
  "block.minecraft.lime_banner": "ທຸງສີຂຽວອ່ອນ",
  "block.minecraft.lime_bed": "ຕຽງສີຂຽວອ່ອນ",
  "block.minecraft.lime_candle": "ທຽນສີຂຽວອ່ອນ",
  "block.minecraft.lime_candle_cake": "ເຄັກພ້ອມທຽນສີຂຽວອ່ອນ",
  "block.minecraft.lime_carpet": "ພົມສີຂຽວອ່ອນ",
  "block.minecraft.lime_concrete": "ຄອນກຣີດສີຂຽວອ່ອນ",
  "block.minecraft.lime_concrete_powder": "ຜົງຄອນກຣີດສີຂຽວອ່ອນ",
  "block.minecraft.lime_glazed_terracotta": "ດິນເຜົາເຄືອບສີຂຽວອ່ອນ",
  "block.minecraft.lime_shulker_box": "ກ່ອງເຊົາເກີສີຂຽວອ່ອນ",
  "block.minecraft.lime_stained_glass": "ແວ່ນດ່າງສີຂຽວອ່ອນ",
  "block.minecraft.lime_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຂຽວອ່ອນ",
  "block.minecraft.lime_terracotta": "ດິນເຜົາສີຂຽວອ່ອນ",
  "block.minecraft.lime_wool": "ຂົນແກະສີຂຽວອ່ອນ",
  "block.minecraft.lodestone": "ຫີນນຳທາງ",
  "block.minecraft.loom": "ກີ່",
  "block.minecraft.magenta_banner": "ທຸງສີມ້ວງແດງ",
  "block.minecraft.magenta_bed": "ຕຽງສີມ້ວງແດງ",
  "block.minecraft.magenta_candle": "ທຽນສີມ້ວງແດງ",
  "block.minecraft.magenta_candle_cake": "ເຄັກພ້ອມທຽນສີມ້ວງແດງ",
  "block.minecraft.magenta_carpet": "ພົມສີມ້ວງແດງ",
  "block.minecraft.magenta_concrete": "ຄອນກຣີດສີມ້ວງແດງ",
  "block.minecraft.magenta_concrete_powder": "ຜົງຄອນກຣີດສີມ້ວງແດງ",
  "block.minecraft.magenta_glazed_terracotta": "ດິນເຜົາເຄືອບສີມ້ວງແດງ",
  "block.minecraft.magenta_shulker_box": "ກ່ອງເຊົາເກີສີມ້ວງແດງ",
  "block.minecraft.magenta_stained_glass": "ແວ່ນດ່າງສີມ້ວງແດງ",
  "block.minecraft.magenta_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີມ້ວງແດງ",
  "block.minecraft.magenta_terracotta": "ດິນເຜົາສີມ້ວງແດງ",
  "block.minecraft.magenta_wool": "ຂົນແກະສີມ້ວງແດງ",
  "block.minecraft.magma_block": "ບລ໋ອກແມັກມ່າ",
  "block.minecraft.mangrove_button": "ປຸ່ມໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_door": "ປະຕູໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_fence": "ຮົ້ວໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_fence_gate": "ປະຕູຮົ້ວໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_leaves": "ໃບໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_log": "ຂອນໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_planks": "ແປ້ນໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_pressure_plate": "ແປ້ນຢຽບໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_propagule": "ໜໍ່ພັນໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_roots": "ຮາກໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "ປ້າຍໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_slab": "ແຜ່ນໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_stairs": "ຄັນໄດໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_trapdoor": "ປະຕູກັບດັກໄມ້ໂກງກາງ",
  "block.minecraft.mangrove_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂກງກາງຕິດຝາ",
  "block.minecraft.mangrove_wall_sign": "ປ້າຍໄມ້ໂກງກາງຕິດຝາ",
  "block.minecraft.mangrove_wood": "ໄມ້ໂກງກາງ",
  "block.minecraft.medium_amethyst_bud": "ໜໍ່ອາເມທິສຂະໜາດກາງ",
  "block.minecraft.melon": "ໝາກໂມ",
  "block.minecraft.melon_stem": "ລຳຕົ້ນໝາກໂມ",
  "block.minecraft.moss_block": "ບລ໋ອກຂີ້ໄຄ",
  "block.minecraft.moss_carpet": "ພົມຂີ້ໄຄ",
  "block.minecraft.mossy_cobblestone": "ຫີນຫຍາບຂີ້ໄຄ",
  "block.minecraft.mossy_cobblestone_slab": "ແຜ່ນຫີນຫຍາບຂີ້ໄຄ",
  "block.minecraft.mossy_cobblestone_stairs": "ຄັນໄດຫີນຫຍາບຂີ້ໄຄ",
  "block.minecraft.mossy_cobblestone_wall": "ກຳແພງຫີນຫຍາບຂີ້ໄຄ",
  "block.minecraft.mossy_stone_brick_slab": "ແຜ່ນດິນຈີ່ຫີນຂີ້ໄຄ",
  "block.minecraft.mossy_stone_brick_stairs": "ຄັນໄດດິນຈີ່ຫີນຂີ້ໄຄ",
  "block.minecraft.mossy_stone_brick_wall": "ກຳແພງດິນຈີ່ຫີນຂີ້ໄຄ",
  "block.minecraft.mossy_stone_bricks": "ດິນຈີ່ຫີນຂີ້ໄຄ",
  "block.minecraft.moving_piston": "ລູກສູບເຄື່ອນ",
  "block.minecraft.mud": "ຂີ້ຕົມ",
  "block.minecraft.mud_brick_slab": "ແຜ່ນຂີ້ຕົມ",
  "block.minecraft.mud_brick_stairs": "ຄັນໄດຂີ້ຕົມ",
  "block.minecraft.mud_brick_wall": "ກຳແພງຂີ້ຕົມ",
  "block.minecraft.mud_bricks": "ດິນຈີ່ຂີ້ຕົມ",
  "block.minecraft.muddy_mangrove_roots": "ຮາກໄມ້ໂກງກາງຕິດຂີ້ຕົມ",
  "block.minecraft.mushroom_stem": "ລຳຕົ້ນເຫັດ",
  "block.minecraft.mycelium": "ເສັ້ນໃຍລາ",
  "block.minecraft.nether_brick_fence": "ຮົ້ວດິນຈີ່ເນເທີ",
  "block.minecraft.nether_brick_slab": "ແຜ່ນດິນຈີ່ເນເທີ",
  "block.minecraft.nether_brick_stairs": "ຄັນໄດດິນຈີ່ເນເທີ",
  "block.minecraft.nether_brick_wall": "ກຳແພງດິນຈີ່ເນເທີ",
  "block.minecraft.nether_bricks": "ດິນຈີ່ເນເທີ",
  "block.minecraft.nether_gold_ore": "ແຮ່ຄຳເນເທີ",
  "block.minecraft.nether_portal": "ປະຕູມິຕິເນເທີ",
  "block.minecraft.nether_quartz_ore": "ແຮ່ມະນີສິລາເນເທີ",
  "block.minecraft.nether_sprouts": "ຕົ້ນອ່ອນເນເທີ",
  "block.minecraft.nether_wart": "ຂີ້ກະຕອດເນເທີ",
  "block.minecraft.nether_wart_block": "ບລ໋ອກຂີ້ກະຕອດເນເທີ",
  "block.minecraft.netherite_block": "ບລ໋ອກເນເທີໄຣ",
  "block.minecraft.netherrack": "ຫີນເນເທີ",
  "block.minecraft.note_block": "ກ່ອງໂຕໂນ໊ດ",
  "block.minecraft.oak_button": "ປຸ່ມໄມ້ໂອກ",
  "block.minecraft.oak_door": "ປະຕູໄມ້ໂອກ",
  "block.minecraft.oak_fence": "ຮົ້ວໄມ້ໂອກ",
  "block.minecraft.oak_fence_gate": "ປະຕູຮົ້ວໄມ້ໂອກ",
  "block.minecraft.oak_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂອກ",
  "block.minecraft.oak_leaves": "ໃບໄມ້ໂອກ",
  "block.minecraft.oak_log": "ຂອນໄມ້ໂອກ",
  "block.minecraft.oak_planks": "ແປ້ນໄມ້ໂອກ",
  "block.minecraft.oak_pressure_plate": "ແປ້ນຢຽບໄມ້ໂອກ",
  "block.minecraft.oak_sapling": "ເບ້ຍໄມ້ໂອກ",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "ປ້າຍໄມ້ໂອກ",
  "block.minecraft.oak_slab": "ແຜ່ນໄມ້ໂອກ",
  "block.minecraft.oak_stairs": "ຄັນໄດໄມ້ໂອກ",
  "block.minecraft.oak_trapdoor": "ປະຕູກັບດັກໄມ້ໂອກ",
  "block.minecraft.oak_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ໂອກຕິດຝາ",
  "block.minecraft.oak_wall_sign": "ປ້າຍໄມ້ໂອກຕິດຝາ",
  "block.minecraft.oak_wood": "ໄມ້ໂອກ",
  "block.minecraft.observer": "ໂຕສັງເກດການ",
  "block.minecraft.obsidian": "ຫີນອ໋ອບຊິດ້ຽນ",
  "block.minecraft.ochre_froglight": "ໄຟກົບສີດິນເຫຼືອງ",
  "block.minecraft.ominous_banner": "ທຸງແຫ່ງລາງຮ້າຍ",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "ທຸງສີສົ້ມ",
  "block.minecraft.orange_bed": "ຕຽງສີສົ້ມ",
  "block.minecraft.orange_candle": "ທຽນສີສົ້ມ",
  "block.minecraft.orange_candle_cake": "ເຄັກພ້ອມທຽນສີສົ້ມ",
  "block.minecraft.orange_carpet": "ພົມສີສົ້ມ",
  "block.minecraft.orange_concrete": "ຄອນກຣີດສີສົ້ມ",
  "block.minecraft.orange_concrete_powder": "ຜົງຄອນກຣີດສີສົ້ມ",
  "block.minecraft.orange_glazed_terracotta": "ດິນເຜົາເຄືອບສີສົ້ມ",
  "block.minecraft.orange_shulker_box": "ກ່ອງເຊົາເກີສີສົ້ມ",
  "block.minecraft.orange_stained_glass": "ແວ່ນດ່າງສີສົ້ມ",
  "block.minecraft.orange_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີສົ້ມ",
  "block.minecraft.orange_terracotta": "ດິນເຜົາສີສົ້ມ",
  "block.minecraft.orange_tulip": "ດອກທິວລິບສົ້ມ",
  "block.minecraft.orange_wool": "ຂົນແກະສີສົ້ມ",
  "block.minecraft.oxeye_daisy": "ດອກອ໋ອກອາຍເດຊີ່",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "ທອງແດງຂຶ້ນໝ້ຽງ",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "ທອງແດງຕັດຂຶ້ນໝ້ຽງ",
  "block.minecraft.oxidized_cut_copper_slab": "ແຜ່ນທອງແດງຕັດຂຶ້ນໝ້ຽງ",
  "block.minecraft.oxidized_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດຂຶ້ນໝ້ຽງ",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "ນ້ຳກ້ອນອັດແໜ້ນ",
  "block.minecraft.packed_mud": "ຂີ້ຕົມອັດແໜ້ນ",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "ແປ້ນໄມ້ໂອກດຳ",
  "block.minecraft.pale_oak_pressure_plate": "ແປ້ນຢຽບໄມ້ໂອກດຳ",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "ໄຟກົບສີປະກາຍໄຂ່ມຸກ",
  "block.minecraft.peony": "ດອກໂບຕັນ",
  "block.minecraft.petrified_oak_slab": "ແຜ່ນໄມ້ໂອກກາຍເປັນຫີນ",
  "block.minecraft.piglin_head": "ຫົວພິກລິນ",
  "block.minecraft.piglin_wall_head": "ຫົວພິກລິນຕິດຝາ",
  "block.minecraft.pink_banner": "ທຸງສີບົວ",
  "block.minecraft.pink_bed": "ຕຽງສີບົວ",
  "block.minecraft.pink_candle": "ທຽນສີບົວ",
  "block.minecraft.pink_candle_cake": "ເຄັກພ້ອມທຽນສີບົວ",
  "block.minecraft.pink_carpet": "ພົມສີບົວ",
  "block.minecraft.pink_concrete": "ຄອນກຣີດສີບົວ",
  "block.minecraft.pink_concrete_powder": "ຜົງຄອນກຣີດສີບົວ",
  "block.minecraft.pink_glazed_terracotta": "ດິນເຜົາເຄືອບສີບົວ",
  "block.minecraft.pink_petals": "ກີບດອກສີບົວ",
  "block.minecraft.pink_shulker_box": "ກ່ອງເຊົາເກີສີບົວ",
  "block.minecraft.pink_stained_glass": "ແວ່ນດ່າງສີບົວ",
  "block.minecraft.pink_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີບົວ",
  "block.minecraft.pink_terracotta": "ດິນເຜົາສີບົວ",
  "block.minecraft.pink_tulip": "ດອກທິວລິບບົວ",
  "block.minecraft.pink_wool": "ຂົນແກະສີບົວ",
  "block.minecraft.piston": "ລູກສູບ",
  "block.minecraft.piston_head": "ຫົວລູກສູບ",
  "block.minecraft.pitcher_crop": "ໝາກໝໍ້ເຂົ້າໝໍ້ແກງລິງ",
  "block.minecraft.pitcher_plant": "ຕົ້ນໝໍ້ເຂົ້າໝໍ້ແກງລິງ",
  "block.minecraft.player_head": "ຫົວຜູ້ຫຼິ້ນ",
  "block.minecraft.player_head.named": "ຫົວຂອງ %s",
  "block.minecraft.player_wall_head": "ຫົວຜູ້ຫຼິ້ນຕິດຝາ",
  "block.minecraft.podzol": "ດິນພອດຊໍ",
  "block.minecraft.pointed_dripstone": "ຫີນຍ້ອຍແຫຼມ",
  "block.minecraft.polished_andesite": "ຫີນແອນດີໄຊທ໌ຂັດ",
  "block.minecraft.polished_andesite_slab": "ແຜ່ນຫີນແອນດີໄຊທ໌ຂັດ",
  "block.minecraft.polished_andesite_stairs": "ຄັນໄດຫີນແອນດີໄຊທ໌ຂັດ",
  "block.minecraft.polished_basalt": "ຫີນບະຊໍຂັດ",
  "block.minecraft.polished_blackstone": "ຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_brick_slab": "ແຜ່ນດິນຈີ່ຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_brick_stairs": "ຄັນໄດດິນຈີ່ຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_brick_wall": "ກຳແພງດິນຈີ່ຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_bricks": "ດິນຈີ່ຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_button": "ປຸ່ມຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_pressure_plate": "ແປ້ນຢຽບຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_slab": "ແຜ່ນຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_stairs": "ຄັນໄດຫີນດຳຂັດ",
  "block.minecraft.polished_blackstone_wall": "ກຳແພງຫີນດຳຂັດ",
  "block.minecraft.polished_deepslate": "ຫີນຊະນວນເລິກຂັດ",
  "block.minecraft.polished_deepslate_slab": "ແຜ່ນຫີນຊະນວນເລິກຂັດ",
  "block.minecraft.polished_deepslate_stairs": "ຄັນໄດຫີນຊະນວນເລິກຂັດ",
  "block.minecraft.polished_deepslate_wall": "ກຳແພງຫີນຊະນວນເລິກຂັດ",
  "block.minecraft.polished_diorite": "ຫີນໄດອໍໄຣທ໌ຂັດ",
  "block.minecraft.polished_diorite_slab": "ແຜ່ນຫີນໄດອໍໄຣທ໌ຂັດ",
  "block.minecraft.polished_diorite_stairs": "ຄັນໄດຫີນໄດອໍໄຣທ໌ຂັດ",
  "block.minecraft.polished_granite": "ຫີນແກຣນິດຂັດ",
  "block.minecraft.polished_granite_slab": "ແຜ່ນຫີນແກຣນິດຂັດ",
  "block.minecraft.polished_granite_stairs": "ຄັນໄດຫີນແກຣນິດຂັດ",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "ດອກປ໋ອບປີ້",
  "block.minecraft.potatoes": "ມັນຝຣັ່ງ",
  "block.minecraft.potted_acacia_sapling": "ໂຖເບ້ຍອາເຄເຊຍ",
  "block.minecraft.potted_allium": "ໂຖດອກອາວລຽມ",
  "block.minecraft.potted_azalea_bush": "ໂຖກຸຫຼາບພັນປີ",
  "block.minecraft.potted_azure_bluet": "ໂຖດອກອາຊົວບລູເອັດ",
  "block.minecraft.potted_bamboo": "ໂຖໄມ້ໄຜ່",
  "block.minecraft.potted_birch_sapling": "ໂຖເບ້ຍໄມ້ຢືນຕົ້ນ",
  "block.minecraft.potted_blue_orchid": "ໂຖດອກເອື້ອງຟ້າ",
  "block.minecraft.potted_brown_mushroom": "ໂຖເຫັດສີນ້ຳຕານ",
  "block.minecraft.potted_cactus": "ໂຖຕົ້ນກະບອງເພັດ",
  "block.minecraft.potted_cherry_sapling": "ໂຖເບ້ຍຊາກຸຣະ",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "ໂຖຄອຣ໌ນຟລາວເວີ",
  "block.minecraft.potted_crimson_fungus": "ໂຖເຫັດເຊື້ອລາສີເລືອດ",
  "block.minecraft.potted_crimson_roots": "ໂຖຮາກໄມ້ສີເລືອດ",
  "block.minecraft.potted_dandelion": "ໂຖດອກແດນດິໄລອອນ",
  "block.minecraft.potted_dark_oak_sapling": "ໂຖເບ້ຍໄມ້ໂອກດຳ",
  "block.minecraft.potted_dead_bush": "ໂຖຟຸ່ມໄມ້ແຫ້ງ",
  "block.minecraft.potted_fern": "ໂຖຜັກກູດ",
  "block.minecraft.potted_flowering_azalea_bush": "ໂຖກຸຫຼາບພັນປີມີດອກ",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "ໂຖເບ້ຍໄມ້ປ່າດົງດິບ",
  "block.minecraft.potted_lily_of_the_valley": "ໂຖລິນລີ່ແຫ່ງຮ່ອມພູ",
  "block.minecraft.potted_mangrove_propagule": "ໂຖໜໍ່ພັນໄມ້ໂກງກາງ",
  "block.minecraft.potted_oak_sapling": "ໂຖເບ້ຍໄມ້ໂອກ",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "ໂຖດອກທິວລິບສົ້ມ",
  "block.minecraft.potted_oxeye_daisy": "ໂຖດອກອ໋ອກອາຍເດຊີ່",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "ໂຖດອກທິວລິບບົວ",
  "block.minecraft.potted_poppy": "ໂຖດອກປ໋ອບປີ້",
  "block.minecraft.potted_red_mushroom": "ໂຖເຫັດສີແດງ",
  "block.minecraft.potted_red_tulip": "ໂຖດອກທິວລິບແດງ",
  "block.minecraft.potted_spruce_sapling": "ໂຖເບ້ຍສະປຣູດ",
  "block.minecraft.potted_torchflower": "ໂຖດອກຄົບໄຟ",
  "block.minecraft.potted_warped_fungus": "ໂຖເຫັດເຊື້ອລາຜີບ້າ",
  "block.minecraft.potted_warped_roots": "ໂຖຮາກໄມ້ຜີບ້າ",
  "block.minecraft.potted_white_tulip": "ໂຖດອກທິວລິບຂາວ",
  "block.minecraft.potted_wither_rose": "ໂຖກຸຫຼາບວິດເທີ",
  "block.minecraft.powder_snow": "ຫິມະຜົງ",
  "block.minecraft.powder_snow_cauldron": "ໝໍ້ປຸງຢາຫິມະຜົງ",
  "block.minecraft.powered_rail": "ລາງຂັບເຄື່ອນ",
  "block.minecraft.prismarine": "ພຣິສມາຣີນ",
  "block.minecraft.prismarine_brick_slab": "ແຜ່ນດິນຈີ່ພຣິສມາຣີນ",
  "block.minecraft.prismarine_brick_stairs": "ຄັນໄດດິນຈີ່ພຣິສມາຣີນ",
  "block.minecraft.prismarine_bricks": "ດິນຈີ່ພຣິສມາຣີນ",
  "block.minecraft.prismarine_slab": "ແຜ່ນພຣິສມາຣີນ",
  "block.minecraft.prismarine_stairs": "ຄັນໄດພຣິສມາຣີນ",
  "block.minecraft.prismarine_wall": "ກຳແພງພຣິສມາຣີນ",
  "block.minecraft.pumpkin": "ໝາກອຶ",
  "block.minecraft.pumpkin_stem": "ລຳຕົ້ນໝາກອຶ",
  "block.minecraft.purple_banner": "ທຸງສີມ້ວງ",
  "block.minecraft.purple_bed": "ຕຽງສີມ້ວງ",
  "block.minecraft.purple_candle": "ທຽນສີມ້ວງ",
  "block.minecraft.purple_candle_cake": "ເຄັກພ້ອມທຽນສີມ້ວງ",
  "block.minecraft.purple_carpet": "ພົມສີມ້ວງ",
  "block.minecraft.purple_concrete": "ຄອນກຣີດສີມ້ວງ",
  "block.minecraft.purple_concrete_powder": "ຜົງຄອນກຣີດສີມ້ວງ",
  "block.minecraft.purple_glazed_terracotta": "ດິນເຜົາເຄືອບສີມ້ວງ",
  "block.minecraft.purple_shulker_box": "ກ່ອງເຊົາເກີສີມ້ວງ",
  "block.minecraft.purple_stained_glass": "ແວ່ນດ່າງສີມ້ວງ",
  "block.minecraft.purple_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີມ້ວງ",
  "block.minecraft.purple_terracotta": "ດິນເຜົາສີມ້ວງ",
  "block.minecraft.purple_wool": "ຂົນແກະສີມ້ວງ",
  "block.minecraft.purpur_block": "ບລ໋ອກເພີຣ໌ເພີຣ໌",
  "block.minecraft.purpur_pillar": "ເສົາເພີຣ໌ເພີຣ໌",
  "block.minecraft.purpur_slab": "ແຜ່ນເພີຣ໌ເພີຣ໌",
  "block.minecraft.purpur_stairs": "ຄັນໄດເພີຣ໌ເພີຣ໌",
  "block.minecraft.quartz_block": "ບລ໋ອກມະນີສິລາ",
  "block.minecraft.quartz_bricks": "ດິນຈີ່ມະນີສິລາ",
  "block.minecraft.quartz_pillar": "ເສົາມະນີສິລາ",
  "block.minecraft.quartz_slab": "ແຜ່ນມະນີສິລາ",
  "block.minecraft.quartz_stairs": "ຄັນໄດມະນີສິລາ",
  "block.minecraft.rail": "ລາງ",
  "block.minecraft.raw_copper_block": "ບລ໋ອກທອງແດງດິບ",
  "block.minecraft.raw_gold_block": "ບລ໋ອກຄຳດິບ",
  "block.minecraft.raw_iron_block": "ບລ໋ອກເຫຼັກດິບ",
  "block.minecraft.red_banner": "ທຸງສີແດງ",
  "block.minecraft.red_bed": "ຕຽງສີແດງ",
  "block.minecraft.red_candle": "ທຽນສີແດງ",
  "block.minecraft.red_candle_cake": "ເຄັກພ້ອມທຽນສີແດງ",
  "block.minecraft.red_carpet": "ພົມສີແດງ",
  "block.minecraft.red_concrete": "ຄອນກຣີດສີແດງ",
  "block.minecraft.red_concrete_powder": "ຜົງຄອນກຣີດສີແດງ",
  "block.minecraft.red_glazed_terracotta": "ດິນເຜົາເຄືອບສີແດງ",
  "block.minecraft.red_mushroom": "ເຫັດສີແດງ",
  "block.minecraft.red_mushroom_block": "ບລ໋ອກເຫັດສີແດງ",
  "block.minecraft.red_nether_brick_slab": "ແຜ່ນດິນຈີ່ເນເທີແດງ",
  "block.minecraft.red_nether_brick_stairs": "ຄັນໄດດິນຈີ່ເນເທີແດງ",
  "block.minecraft.red_nether_brick_wall": "ກຳແພງດິນຈີ່ເນເທີແດງ",
  "block.minecraft.red_nether_bricks": "ດິນຈີ່ເນເທີແດງ",
  "block.minecraft.red_sand": "ຊາຍແດງ",
  "block.minecraft.red_sandstone": "ຫີນຊາຍແດງ",
  "block.minecraft.red_sandstone_slab": "ແຜ່ນຫີນຊາຍແດງ",
  "block.minecraft.red_sandstone_stairs": "ຄັນໄດຫີນຊາຍແດງ",
  "block.minecraft.red_sandstone_wall": "ກຳແພງຫີນຊາຍແດງ",
  "block.minecraft.red_shulker_box": "ກ່ອງເຊົາເກີສີແດງ",
  "block.minecraft.red_stained_glass": "ແວ່ນດ່າງສີແດງ",
  "block.minecraft.red_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີແດງ",
  "block.minecraft.red_terracotta": "ດິນເຜົາສີແດງ",
  "block.minecraft.red_tulip": "ດອກທິວລິບແດງ",
  "block.minecraft.red_wool": "ຂົນແກະສີແດງ",
  "block.minecraft.redstone_block": "ບລ໋ອກຫີນແດງ",
  "block.minecraft.redstone_lamp": "ຫຼອດໄຟຫີນແດງ",
  "block.minecraft.redstone_ore": "ແຮ່ຫີນແດງ",
  "block.minecraft.redstone_torch": "ຄົບໄຟຫີນແດງ",
  "block.minecraft.redstone_wall_torch": "ຄົບໄຟຫີນແດງຕິດຝາ",
  "block.minecraft.redstone_wire": "ສາຍໄຟຫີນແດງ",
  "block.minecraft.reinforced_deepslate": "ຫີນຊະນວນເລິກເສີມແຮງ",
  "block.minecraft.repeater": "ໂຕທວນສັນຍານຫີນແດງ",
  "block.minecraft.repeating_command_block": "ບລ໋ອກຄຳສັ່ງແບບເຮັດຊ້ຳ",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "ຫຼັກຈຸດເກີດ",
  "block.minecraft.rooted_dirt": "ດິນຝັງຮາກ",
  "block.minecraft.rose_bush": "ຟຸ່ມດອກກຸຫຼາບ",
  "block.minecraft.sand": "ຊາຍ",
  "block.minecraft.sandstone": "ຫີນຊາຍ",
  "block.minecraft.sandstone_slab": "ແຜ່ນຫີນຊາຍ",
  "block.minecraft.sandstone_stairs": "ຄັນໄດຫີນຊາຍ",
  "block.minecraft.sandstone_wall": "ກຳແພງຫີນຊາຍ",
  "block.minecraft.scaffolding": "ນັ່ງຮ້ານ",
  "block.minecraft.sculk": "ສະເກົາ",
  "block.minecraft.sculk_catalyst": "ສະເກົາໂຕເລັ່ງ",
  "block.minecraft.sculk_sensor": "ສະເກົາກວດຈັບ",
  "block.minecraft.sculk_shrieker": "ສະເກົາຫວີດຮ້ອງ",
  "block.minecraft.sculk_vein": "ເສັ້ນໃຍສະເກົາ",
  "block.minecraft.sea_lantern": "ໂຄມໄຟທະເລ",
  "block.minecraft.sea_pickle": "ໝາກແຕງດອງທະເລ",
  "block.minecraft.seagrass": "ຫຍ້າທະເລ",
  "block.minecraft.set_spawn": "ຕັ້ງຈຸດເກີດໃໝ່ແລ້ວ",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "ບລ໋ອກເຮືອງແສງ",
  "block.minecraft.shulker_box": "ກ່ອງເຊົາເກີ",
  "block.minecraft.skeleton_skull": "ຫົວກະໂຫຼກໂຄງກະດູກ",
  "block.minecraft.skeleton_wall_skull": "ຫົວກະໂຫຼກໂຄງກະດູກຕິດຝາ",
  "block.minecraft.slime_block": "ບລ໋ອກສະລາມ",
  "block.minecraft.small_amethyst_bud": "ໜໍ່ອາເມທິສຂະໜາດນ້ອຍ",
  "block.minecraft.small_dripleaf": "ໃບຍ້ອຍນ້ອຍ",
  "block.minecraft.smithing_table": "ໂຕະເຮັດອາວຸດ",
  "block.minecraft.smoker": "ເຕົາຮົມຄວັນ",
  "block.minecraft.smooth_basalt": "ຫີນບະຊໍກ້ຽງ",
  "block.minecraft.smooth_quartz": "ບລ໋ອກມະນີສິລາກ້ຽງ",
  "block.minecraft.smooth_quartz_slab": "ແຜ່ນມະນີສິລາກ້ຽງ",
  "block.minecraft.smooth_quartz_stairs": "ຄັນໄດມະນີສິລາກ້ຽງ",
  "block.minecraft.smooth_red_sandstone": "ຫີນຊາຍແດງກ້ຽງ",
  "block.minecraft.smooth_red_sandstone_slab": "ແຜ່ນຫີນຊາຍແດງກ້ຽງ",
  "block.minecraft.smooth_red_sandstone_stairs": "ຄັນໄດຫີນຊາຍແດງກ້ຽງ",
  "block.minecraft.smooth_sandstone": "ຫີນຊາຍກ້ຽງ",
  "block.minecraft.smooth_sandstone_slab": "ແຜ່ນຫີນຊາຍກ້ຽງ",
  "block.minecraft.smooth_sandstone_stairs": "ຄັນໄດຫີນຊາຍກ້ຽງ",
  "block.minecraft.smooth_stone": "ຫີນກ້ຽງ",
  "block.minecraft.smooth_stone_slab": "ແຜ່ນຫີນກ້ຽງ",
  "block.minecraft.sniffer_egg": "ໄຂ່ສະນິບເຟີ",
  "block.minecraft.snow": "ຫິມະ",
  "block.minecraft.snow_block": "ບລ໋ອກຫິມະ",
  "block.minecraft.soul_campfire": "ແຄັມໄຟວິນຍານ",
  "block.minecraft.soul_fire": "ໄຟວິນຍານ",
  "block.minecraft.soul_lantern": "ໂຄມໄຟວິນຍານ",
  "block.minecraft.soul_sand": "ຊາຍວິນຍານ",
  "block.minecraft.soul_soil": "ດິນວິນຍານ",
  "block.minecraft.soul_torch": "ຄົບໄຟວິນຍານ",
  "block.minecraft.soul_wall_torch": "ຄົບໄຟວິນຍານຕິດຝາ",
  "block.minecraft.spawn.not_valid": "ບໍ່ພົບຕຽງ ຫຼື ຫຼັກຈຸດເກີດຂອງເຈົ້າ ຫຼື ມີສິ່ງກີດຂວາງໄວ້",
  "block.minecraft.spawner": "ກົງກຳເນີດສັດປະຫຼາດ",
  "block.minecraft.spawner.desc1": "ປະຕິສຳພັນກັບໄຂ່ເກີດ:",
  "block.minecraft.spawner.desc2": "ເລືອກປະເພດມ໋ອບ",
  "block.minecraft.sponge": "ຟອງນ້ຳ",
  "block.minecraft.spore_blossom": "ດອກສະປໍ",
  "block.minecraft.spruce_button": "ປຸ່ມໄມ້ສະປຣູດ",
  "block.minecraft.spruce_door": "ປະຕູໄມ້ສະປຣູດ",
  "block.minecraft.spruce_fence": "ຮົ້ວໄມ້ສະປຣູດ",
  "block.minecraft.spruce_fence_gate": "ປະຕູຮົ້ວໄມ້ສະປຣູດ",
  "block.minecraft.spruce_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ສະປຣູດ",
  "block.minecraft.spruce_leaves": "ໃບໄມ້ສະປຣູດ",
  "block.minecraft.spruce_log": "ຂອນໄມ້ສະປຣູດ",
  "block.minecraft.spruce_planks": "ແປ້ນໄມ້ສະປຣູດ",
  "block.minecraft.spruce_pressure_plate": "ແປ້ນຢຽບໄມ້ສະປຣູດ",
  "block.minecraft.spruce_sapling": "ເບ້ຍສະປຣູດ",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "ປ້າຍໄມ້ສະປຣູດ",
  "block.minecraft.spruce_slab": "ແຜ່ນໄມ້ສະປຣູດ",
  "block.minecraft.spruce_stairs": "ຄັນໄດໄມ້ສະປຣູດ",
  "block.minecraft.spruce_trapdoor": "ປະຕູກັບດັກໄມ້ສະປຣູດ",
  "block.minecraft.spruce_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ສະປຣູດຕິດຝາ",
  "block.minecraft.spruce_wall_sign": "ປ້າຍໄມ້ສະປຣູດຕິດຝາ",
  "block.minecraft.spruce_wood": "ໄມ້ສະປຣູດ",
  "block.minecraft.sticky_piston": "ລູກສູບໜຽວ",
  "block.minecraft.stone": "ຫີນ",
  "block.minecraft.stone_brick_slab": "ແຜ່ນດິນຈີ່ຫີນ",
  "block.minecraft.stone_brick_stairs": "ຄັນໄດດິນຈີ່ຫີນ",
  "block.minecraft.stone_brick_wall": "ກຳແພງດິນຈີ່ຫີນ",
  "block.minecraft.stone_bricks": "ດິນຈີ່ຫີນ",
  "block.minecraft.stone_button": "ປຸ່ມຫີນ",
  "block.minecraft.stone_pressure_plate": "ແປ້ນຢຽບຫີນ",
  "block.minecraft.stone_slab": "ແຜ່ນຫີນ",
  "block.minecraft.stone_stairs": "ຄັນໄດຫີນ",
  "block.minecraft.stonecutter": "ເຄື່ອງຕັດຫີນ",
  "block.minecraft.stripped_acacia_log": "ຂອນໄມ້ອາເຄເຊຍລອກເປືອກ",
  "block.minecraft.stripped_acacia_wood": "ໄມ້ອາເຄເຊຍລອກເປືອກ",
  "block.minecraft.stripped_bamboo_block": "ບລ໋ອກໄມ້ໄຜ່ລອກເປືອກ",
  "block.minecraft.stripped_birch_log": "ຂອນໄມ້ຢືນຕົ້ນລອກເປືອກ",
  "block.minecraft.stripped_birch_wood": "ໄມ້ຢືນຕົ້ນລອກເປືອກ",
  "block.minecraft.stripped_cherry_log": "ຂອນໄມ້ຊາກຸຣະລອກເປືອກ",
  "block.minecraft.stripped_cherry_wood": "ໄມ້ຊາກຸຣະລອກເປືອກ",
  "block.minecraft.stripped_crimson_hyphae": "ໄຮແພສີເລືອດລອກເປືອກ",
  "block.minecraft.stripped_crimson_stem": "ລຳຕົ້ນສີເລືອດລອກເປືອກ",
  "block.minecraft.stripped_dark_oak_log": "ຂອນໄມ້ໂອກດຳລອກເປືອກ",
  "block.minecraft.stripped_dark_oak_wood": "ໄມ້ໂອກດຳລອກເປືອກ",
  "block.minecraft.stripped_jungle_log": "ຂອນໄມ້ປ່າດົງດິບລອກເປືອກ",
  "block.minecraft.stripped_jungle_wood": "ໄມ້ປ່າດົງດິບລອກເປືອກ",
  "block.minecraft.stripped_mangrove_log": "ຂອນໄມ້ໂກງກາງລອກເປືອກ",
  "block.minecraft.stripped_mangrove_wood": "ໄມ້ໂກງກາງລອກເປືອກ",
  "block.minecraft.stripped_oak_log": "ຂອນໄມ້ໂອກລອກເປືອກ",
  "block.minecraft.stripped_oak_wood": "ໄມ້ໂອກລອກເປືອກ",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "ຂອນໄມ້ສະປຣູດລອກເປືອກ",
  "block.minecraft.stripped_spruce_wood": "ໄມ້ສະປຣູດລອກເປືອກ",
  "block.minecraft.stripped_warped_hyphae": "ໄຮແພຜີບ້າລອກເປືອກ",
  "block.minecraft.stripped_warped_stem": "ລຳຕົ້ນປ່າຜີບ້າລອກເປືອກ",
  "block.minecraft.structure_block": "ບລ໋ອກໂຄງສ້າງ",
  "block.minecraft.structure_void": "ບລ໋ອກໂຄງເປົ່າ",
  "block.minecraft.sugar_cane": "ອ້ອຍ",
  "block.minecraft.sunflower": "ດອກຕາເວັນ",
  "block.minecraft.suspicious_gravel": "ຫີນແຮ່ໜ້າສົງໄສ",
  "block.minecraft.suspicious_sand": "ຊາຍໜ້າສົງໄສ",
  "block.minecraft.sweet_berry_bush": "ຟຸ່ມເບີຣີ່ຫວານ",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "ຫຍ້າສູງ",
  "block.minecraft.tall_seagrass": "ຫຍ້າທະເລສູງ",
  "block.minecraft.target": "ເປົ້າຍິງ",
  "block.minecraft.terracotta": "ດິນເຜົາ",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "ແວ່ນສີ",
  "block.minecraft.tnt": "ລະເບີດທີເອັນທີ",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "ຄົບໄຟ",
  "block.minecraft.torchflower": "ດອກຄົບໄຟ",
  "block.minecraft.torchflower_crop": "ຕົ້ນດອກຄົບໄຟ",
  "block.minecraft.trapped_chest": "ຫີບກັບດັກ",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "ເຊືອກກັບດັກ",
  "block.minecraft.tripwire_hook": "ຂໍກ່ຽວເຊືອກກັບດັກ",
  "block.minecraft.tube_coral": "ປະກາລັງຫຼອດ",
  "block.minecraft.tube_coral_block": "ບລ໋ອກປະກາລັງຫຼອດ",
  "block.minecraft.tube_coral_fan": "ປະກາລັງຫຼອດຮູບວີ",
  "block.minecraft.tube_coral_wall_fan": "ປະກາລັງຫຼອດຮູບວີຕິດຝາ",
  "block.minecraft.tuff": "ຫີນພູເຂົາໄຟ",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "ໄຂ່ເຕົ່າ",
  "block.minecraft.twisting_vines": "ເຄືອບິດກຽວ",
  "block.minecraft.twisting_vines_plant": "ຕົ້ນເຄືອບິດກຽວ",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "ໄຟກົບສີຂ້ຽວຂຽວ",
  "block.minecraft.vine": "ເຄືອ",
  "block.minecraft.void_air": "ອາກາດເປົ່າ",
  "block.minecraft.wall_torch": "ຄົບໄຟຕິດຝາ",
  "block.minecraft.warped_button": "ປຸ່ມໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_door": "ປະຕູໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_fence": "ຮົ້ວໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_fence_gate": "ປະຕູຮົ້ວໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_fungus": "ເຫັດເຊື້ອລາຜີບ້າ",
  "block.minecraft.warped_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_hyphae": "ໄຮແພຜີບ້າ",
  "block.minecraft.warped_nylium": "ນີລ້ຽມຜີບ້າ",
  "block.minecraft.warped_planks": "ແປ້ນໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_pressure_plate": "ແປ້ນຢຽບໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_roots": "ຮາກໄມ້ຜີບ້າ",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "ປ້າຍໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_slab": "ແຜ່ນໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_stairs": "ຄັນໄດໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_stem": "ລຳຕົ້ນປ່າຜີບ້າ",
  "block.minecraft.warped_trapdoor": "ປະຕູກັບດັກໄມ້ປ່າຜີບ້າ",
  "block.minecraft.warped_wall_hanging_sign": "ປ້າຍຫ້ອຍໄມ້ປ່າຜີບ້າຕິດຝາ",
  "block.minecraft.warped_wall_sign": "ປ້າຍໄມ້ປ່າຜີບ້າຕິດຝາ",
  "block.minecraft.warped_wart_block": "ບລ໋ອກຂີ້ກະຕອດຜີບ້າ",
  "block.minecraft.water": "ນ້ຳ",
  "block.minecraft.water_cauldron": "ໝໍ້ປຸງຢານ້ຳ",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "ບລ໋ອກທອງແດງເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "ທອງແດງຕັດເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_cut_copper_slab": "ແຜ່ນທອງແດງຕັດເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "ທອງແດງລອກເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "ທອງແດງຕັດລອກເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_exposed_cut_copper_slab": "ແຜ່ນທອງແດງຕັດລອກເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດລອກເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "ທອງແດງຂຶ້ນໝ້ຽງເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "ທອງແດງຕັດຂຶ້ນໝ້ຽງເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "ແຜ່ນທອງແດງຕັດຂຶ້ນໝ້ຽງເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດຂຶ້ນໝ້ຽງເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "ທອງແດງຫ້ຽນເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "ທອງແດງຕັດຫ້ຽນເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_weathered_cut_copper_slab": "ແຜ່ນທອງແດງຕັດຫ້ຽນເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດຫ້ຽນເຄືອບຂີ້ເຜິ້ງ",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "ທອງແດງຫ້ຽນ",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "ທອງແດງຕັດຫ້ຽນ",
  "block.minecraft.weathered_cut_copper_slab": "ແຜ່ນທອງແດງຕັດຫ້ຽນ",
  "block.minecraft.weathered_cut_copper_stairs": "ຄັນໄດທອງແດງຕັດຫ້ຽນ",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "ເຄືອຮ້ອງໄຫ້",
  "block.minecraft.weeping_vines_plant": "ຕົ້ນເຄືອຮ້ອງໄຫ້",
  "block.minecraft.wet_sponge": "ຟອງນ້ຳປຽກ",
  "block.minecraft.wheat": "ຕົ້ນເຂົ້າສາລີ",
  "block.minecraft.white_banner": "ທຸງສີຂາວ",
  "block.minecraft.white_bed": "ຕຽງສີຂາວ",
  "block.minecraft.white_candle": "ທຽນສີຂາວ",
  "block.minecraft.white_candle_cake": "ເຄັກພ້ອມທຽນສີຂາວ",
  "block.minecraft.white_carpet": "ພົມສີຂາວ",
  "block.minecraft.white_concrete": "ຄອນກຣີດສີຂາວ",
  "block.minecraft.white_concrete_powder": "ຜົງຄອນກຣີດສີຂາວ",
  "block.minecraft.white_glazed_terracotta": "ດິນເຜົາເຄືອບສີຂາວ",
  "block.minecraft.white_shulker_box": "ກ່ອງເຊົາເກີສີຂາວ",
  "block.minecraft.white_stained_glass": "ແວ່ນດ່າງສີຂາວ",
  "block.minecraft.white_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີຂາວ",
  "block.minecraft.white_terracotta": "ດິນເຜົາສີຂາວ",
  "block.minecraft.white_tulip": "ດອກທິວລິບຂາວ",
  "block.minecraft.white_wool": "ຂົນແກະສີຂາວ",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "ກຸຫຼາບວິດເທີ",
  "block.minecraft.wither_skeleton_skull": "ຫົວກະໂຫຼກໂຄງກະດູກວິດເທີ",
  "block.minecraft.wither_skeleton_wall_skull": "ຫົວກະໂຫຼກໂຄງກະດູກວິດເທີຕິດຝາ",
  "block.minecraft.yellow_banner": "ທຸງສີເຫຼືອງ",
  "block.minecraft.yellow_bed": "ຕຽງສີເຫຼືອງ",
  "block.minecraft.yellow_candle": "ທຽນສີເຫຼືອງ",
  "block.minecraft.yellow_candle_cake": "ເຄັກພ້ອມທຽນສີເຫຼືອງ",
  "block.minecraft.yellow_carpet": "ພົມສີເຫຼືອງ",
  "block.minecraft.yellow_concrete": "ຄອນກຣີດສີເຫຼືອງ",
  "block.minecraft.yellow_concrete_powder": "ຜົງຄອນກຣີດສີເຫຼືອງ",
  "block.minecraft.yellow_glazed_terracotta": "ດິນເຜົາເຄືອບສີເຫຼືອງ",
  "block.minecraft.yellow_shulker_box": "ກ່ອງເຊົາເກີສີເຫຼືອງ",
  "block.minecraft.yellow_stained_glass": "ແວ່ນດ່າງສີເຫຼືອງ",
  "block.minecraft.yellow_stained_glass_pane": "ແຜ່ນແວ່ນດ່າງສີເຫຼືອງ",
  "block.minecraft.yellow_terracotta": "ດິນເຜົາສີເຫຼືອງ",
  "block.minecraft.yellow_wool": "ຂົນແກະສີເຫຼືອງ",
  "block.minecraft.zombie_head": "ຫົວຊອມບີ້",
  "block.minecraft.zombie_wall_head": "ຫົວຊອມບີ້ຕິດຝາ",
  "item.minecraft.acacia_boat": "ເຮືອໄມ້ອາເຄເຊຍ",
  "item.minecraft.acacia_chest_boat": "ເຮືອໄມ້ອາເຄເຊຍພ້ອມຫີບ",
  "item.minecraft.allay_spawn_egg": "ໄຂ່ເກີດອັນເລ",
  "item.minecraft.amethyst_shard": "ເສດອາເມທິສ",
  "item.minecraft.angler_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍປາຕຶກເບັດ",
  "item.minecraft.angler_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍປາຕຶກເບັດ",
  "item.minecraft.apple": "ແອັບເປິ້ນ",
  "item.minecraft.archer_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍທະນູ",
  "item.minecraft.archer_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍທະນູ",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "ແທ່ນວາງຊຸດເກາະ",
  "item.minecraft.arms_up_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຄົນຍົກແຂນ",
  "item.minecraft.arms_up_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຄົນຍົກແຂນ",
  "item.minecraft.arrow": "ລູກທະນູ",
  "item.minecraft.axolotl_bucket": "ຄຸໃສ່ແອັກໂຊລໍໂຕ",
  "item.minecraft.axolotl_spawn_egg": "ໄຂ່ເກີດແອັກໂຊລໍໂຕ",
  "item.minecraft.baked_potato": "ມັນຝຣັ່ງອົບ",
  "item.minecraft.bamboo_chest_raft": "ແພໄມ້ໄຜ່ພ້ອມຫີບ",
  "item.minecraft.bamboo_raft": "ແພໄມ້ໄຜ່",
  "item.minecraft.bat_spawn_egg": "ໄຂ່ເກີດເຈຍ",
  "item.minecraft.bee_spawn_egg": "ໄຂ່ເກີດເຜິ້ງ",
  "item.minecraft.beef": "ຊີ້ນງົວດິບ",
  "item.minecraft.beetroot": "ບີດຣູດ",
  "item.minecraft.beetroot_seeds": "ເມັດບີດຣູດ",
  "item.minecraft.beetroot_soup": "ແກງບີດຣູດ",
  "item.minecraft.birch_boat": "ເຮືອໄມ້ຢືນຕົ້ນ",
  "item.minecraft.birch_chest_boat": "ເຮືອໄມ້ຢືນຕົ້ນພ້ອມຫີບ",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "ສີຍ້ອມສີດຳ",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍດາບ",
  "item.minecraft.blade_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍດາບ",
  "item.minecraft.blaze_powder": "ຜົງເບລດ",
  "item.minecraft.blaze_rod": "ແທ່ງເບລດ",
  "item.minecraft.blaze_spawn_egg": "ໄຂ່ເກີດເບລດ",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "ສີຍ້ອມສີຟ້າ",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "ກະດູກ",
  "item.minecraft.bone_meal": "ຜົງກະດູກ",
  "item.minecraft.book": "ປຶ້ມ",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "ທະນູ",
  "item.minecraft.bowl": "ຖ້ວຍ",
  "item.minecraft.bread": "ເຂົ້າ​ຈີ່",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍນ້ຳຢາ",
  "item.minecraft.brewer_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍນ້ຳຢາ",
  "item.minecraft.brewing_stand": "ແທ່ນປຸງຢາ",
  "item.minecraft.brick": "ດິນຈີ່",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "ສີຍ້ອມສີນ້ຳຕານ",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "ແປງ",
  "item.minecraft.bucket": "ຄຸ",
  "item.minecraft.bundle": "ຖົງໜັງ",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໄຟ",
  "item.minecraft.burn_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໄຟ",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "ໄຂ່ເກີດອູດ",
  "item.minecraft.carrot": "ກະຫຼົດ",
  "item.minecraft.carrot_on_a_stick": "ກະຫຼົດຕິດເບັດ",
  "item.minecraft.cat_spawn_egg": "ໄຂ່ເກີດແມວ",
  "item.minecraft.cauldron": "ໝໍ້ປຸງຢາ",
  "item.minecraft.cave_spider_spawn_egg": "ໄຂ່ເກີດແມງມຸມຖ້ຳ",
  "item.minecraft.chainmail_boots": "ເກີບໂສ້",
  "item.minecraft.chainmail_chestplate": "ເສື້ອເກາະໂສ້",
  "item.minecraft.chainmail_helmet": "ໝວກໂສ້",
  "item.minecraft.chainmail_leggings": "ໂສ້ງໂສ້",
  "item.minecraft.charcoal": "ຖ່ານໄມ້",
  "item.minecraft.cherry_boat": "ເຮືອໄມ້ຊາກຸຣະ",
  "item.minecraft.cherry_chest_boat": "ເຮືອໄມ້ຊາກຸຣະພ້ອມຫີບ",
  "item.minecraft.chest_minecart": "ລົດລາງພ້ອມຫີບ",
  "item.minecraft.chicken": "ຊີ້ນໄກ່ດິບ",
  "item.minecraft.chicken_spawn_egg": "ໄຂ່ເກີດໄກ່",
  "item.minecraft.chorus_fruit": "ໝາກຄໍຣັສ",
  "item.minecraft.clay_ball": "ກ້ອນດິນດາກ",
  "item.minecraft.clock": "ໂມງ",
  "item.minecraft.coal": "ຖ່ານຫີນ",
  "item.minecraft.coast_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "ເມັດໂກໂກ້",
  "item.minecraft.cod": "ປາຄ໋ອດດິບ",
  "item.minecraft.cod_bucket": "ຄຸປາຄ໋ອດ",
  "item.minecraft.cod_spawn_egg": "ໄຂ່ເກີດປາຄ໋ອດ",
  "item.minecraft.command_block_minecart": "ລົດລາງພ້ອມບລ໋ອກຄຳສັ່ງ",
  "item.minecraft.compass": "ເຂັມທິດ",
  "item.minecraft.cooked_beef": "ສະເຕັກ",
  "item.minecraft.cooked_chicken": "ຊີ້ນໄກ່ປຸງສຸກ",
  "item.minecraft.cooked_cod": "ປາຄ໋ອດປຸງສຸກ",
  "item.minecraft.cooked_mutton": "ຊີ້ນແກະປຸງສຸກ",
  "item.minecraft.cooked_porkchop": "ຊີ້ນໝູປຸງສຸກ",
  "item.minecraft.cooked_rabbit": "ຊີ້ນກະຕ່າຍປຸງສຸກ",
  "item.minecraft.cooked_salmon": "ປາແຊວມອນປຸງສຸກ",
  "item.minecraft.cookie": "ຄຸກກີ້",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "ກ້ອນທອງແດງ",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "ໄຂ່ເກີດງົວ",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.creeper_banner_pattern.desc": "ກາສັນຍະລັກຄຣີບເປີ",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "ໄຂ່ເກີດຄຣີບເປີ",
  "item.minecraft.crossbow": "ໜ້າໄມ້",
  "item.minecraft.crossbow.projectile": "ວັດຖຸພຸ່ງ:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "ສີຍ້ອມສີຟ້າໃສ",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຄຣີບເປີ",
  "item.minecraft.danger_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຄຣີບເປີ",
  "item.minecraft.dark_oak_boat": "ເຮືອໄມ້ໂອກດຳ",
  "item.minecraft.dark_oak_chest_boat": "ເຮືອໄມ້ໂອກດຳພ້ອມຫີບ",
  "item.minecraft.debug_stick": "ແທ່ງໄມ້ດີບັ໊ກ",
  "item.minecraft.debug_stick.empty": "%s ບໍ່ມີຄຸນສົມບັດ",
  "item.minecraft.debug_stick.select": "ເລືອກ \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ໄປຫາ %s",
  "item.minecraft.diamond": "ເພັດ",
  "item.minecraft.diamond_axe": "ຂວານເພັດ",
  "item.minecraft.diamond_boots": "ເກີບເພັດ",
  "item.minecraft.diamond_chestplate": "ເສື້ອເກາະເພັດ",
  "item.minecraft.diamond_helmet": "ໝວກເພັດ",
  "item.minecraft.diamond_hoe": "ຈົກເພັດ",
  "item.minecraft.diamond_horse_armor": "ເກາະມ້າເພັດ",
  "item.minecraft.diamond_leggings": "ໂສ້ງເພັດ",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "ອິປິກເພັດ",
  "item.minecraft.diamond_shovel": "ຊວ້ານເພັດ",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "ດາບເພັດ",
  "item.minecraft.disc_fragment_5": "ຊິ້ນສ່ວນແຜ່ນສຽງ",
  "item.minecraft.disc_fragment_5.desc": "ແຜ່ນສຽງ - 5",
  "item.minecraft.dolphin_spawn_egg": "ໄຂ່ເກີດປາໂລມາ",
  "item.minecraft.donkey_spawn_egg": "ໄຂ່ເກີດລໍ",
  "item.minecraft.dragon_breath": "ລົມຫາຍໃຈມັງກອນ",
  "item.minecraft.dried_kelp": "ສາຫຼ່າຍທະເລແຫ້ງ",
  "item.minecraft.drowned_spawn_egg": "ໄຂ່ເກີດຊອມບີ້ກ້ອງນ້ຳ",
  "item.minecraft.dune_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "ເສດເອັກໂຄ",
  "item.minecraft.egg": "ໄຂ່",
  "item.minecraft.elder_guardian_spawn_egg": "ໄຂ່ເກີດຜູ້ພິທັກອາວຸໂສ",
  "item.minecraft.elytra": "ປີກແມງໄມ້",
  "item.minecraft.emerald": "ມໍລະກົດ",
  "item.minecraft.enchanted_book": "ຕຳລາຮວາຍມົນ",
  "item.minecraft.enchanted_golden_apple": "ແອັບເປິ້ນຄຳຮວາຍມົນ",
  "item.minecraft.end_crystal": "ຜະລຶກເອັນ",
  "item.minecraft.ender_dragon_spawn_egg": "ໄຂ່ເກີດມັງກອນເອັນເດີ",
  "item.minecraft.ender_eye": "ດວງຕາແຫ່ງເອັນເດີ",
  "item.minecraft.ender_pearl": "ໄຂ່ມຸກເອັນເດີ",
  "item.minecraft.enderman_spawn_egg": "ໄຂ່ເກີດເອັນເດີແມນ",
  "item.minecraft.endermite_spawn_egg": "ໄຂ່ເກີດເອັນເດີໄມ",
  "item.minecraft.evoker_spawn_egg": "ໄຂ່ເກີດອີໂວກເກີ",
  "item.minecraft.experience_bottle": "ແກ້ວນ້ຳແຫ່ງເວດມົນ",
  "item.minecraft.explorer_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍນັກສຳຫຼວດ",
  "item.minecraft.explorer_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍນັກສຳຫຼວດ",
  "item.minecraft.eye_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "ຂົນນົກ",
  "item.minecraft.fermented_spider_eye": "ຕາແມງມຸມດອງ",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "ແຜນທີ່",
  "item.minecraft.fire_charge": "ລູກໄຟ",
  "item.minecraft.firework_rocket": "ຈະຫຼວດພຸ",
  "item.minecraft.firework_rocket.flight": "ໄລຍະເວລາບິນ:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "ດາວພຸ",
  "item.minecraft.firework_star.black": "ສີດຳ",
  "item.minecraft.firework_star.blue": "ສີຟ້າ",
  "item.minecraft.firework_star.brown": "ສີນ້ຳຕານ",
  "item.minecraft.firework_star.custom_color": "ກຳນົດເອງ",
  "item.minecraft.firework_star.cyan": "ສີຟ້າໃສ",
  "item.minecraft.firework_star.fade_to": "ຈາງລົງເປັນ",
  "item.minecraft.firework_star.flicker": "ຍິບຍັບ",
  "item.minecraft.firework_star.gray": "ສີເທົາ",
  "item.minecraft.firework_star.green": "ສີຂຽວ",
  "item.minecraft.firework_star.light_blue": "ສີຟ້າອ່ອນ",
  "item.minecraft.firework_star.light_gray": "ສີເທົາອ່ອນ",
  "item.minecraft.firework_star.lime": "ສີຂຽວອ່ອນ",
  "item.minecraft.firework_star.magenta": "ສີມ້ວງແດງ",
  "item.minecraft.firework_star.orange": "ສີສົ້ມ",
  "item.minecraft.firework_star.pink": "ສີບົວ",
  "item.minecraft.firework_star.purple": "ສີມ້ວງ",
  "item.minecraft.firework_star.red": "ສີແດງ",
  "item.minecraft.firework_star.shape": "ບໍ່ຮູ້ຮູບຮ່າງ",
  "item.minecraft.firework_star.shape.burst": "ລະເບີດ",
  "item.minecraft.firework_star.shape.creeper": "ຮູບຊົງຄຣີບເປີ",
  "item.minecraft.firework_star.shape.large_ball": "ກ້ອນໃຫຍ່",
  "item.minecraft.firework_star.shape.small_ball": "ກ້ອນນ້ອຍ",
  "item.minecraft.firework_star.shape.star": "ຮູບດາວ",
  "item.minecraft.firework_star.trail": "ເສັ້ນທາງ",
  "item.minecraft.firework_star.white": "ສີຂາວ",
  "item.minecraft.firework_star.yellow": "ສີເຫຼືອງ",
  "item.minecraft.fishing_rod": "ຄັນ​ເບັດຕຶກປາ",
  "item.minecraft.flint": "ຫີນເຫຼັກໄຟ",
  "item.minecraft.flint_and_steel": "ຫີນເຫຼັກໄຟກັບເຫຼັກກ້າ",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.flower_banner_pattern.desc": "ກາສັນຍະລັກດອກໄມ້",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "ໂຖດອກໄມ້",
  "item.minecraft.fox_spawn_egg": "ໄຂ່ເກີດໝາຈອກ",
  "item.minecraft.friend_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໝູ່",
  "item.minecraft.friend_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໝູ່",
  "item.minecraft.frog_spawn_egg": "ໄຂ່ເກີດກົບ",
  "item.minecraft.furnace_minecart": "ລົດລາງພ້ອມເຕົາເຜົາ",
  "item.minecraft.ghast_spawn_egg": "ໄຂ່ເກີດແກ໊ສ",
  "item.minecraft.ghast_tear": "ນ້ຳຕາແກ໊ສ",
  "item.minecraft.glass_bottle": "ຕຸກແກ້ວ",
  "item.minecraft.glistering_melon_slice": "ປ່ຽງໝາກໂມຄຳ",
  "item.minecraft.globe_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.globe_banner_pattern.desc": "ໜ່ວຍໂລກ",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "ເບີຣີ່ເຮືອງແສງ",
  "item.minecraft.glow_ink_sac": "ຖົງໝຶກເຮືອງແສງ",
  "item.minecraft.glow_item_frame": "ຂອບໄອເທັມເຮືອງແສງ",
  "item.minecraft.glow_squid_spawn_egg": "ໄຂ່ເກີດປາໝຶກເຮືອງແສງ",
  "item.minecraft.glowstone_dust": "ຜົງຫີນເຮືອງແສງ",
  "item.minecraft.goat_horn": "ເຂົາແບ້",
  "item.minecraft.goat_spawn_egg": "ໄຂ່ເກີດແບ້",
  "item.minecraft.gold_ingot": "ກ້ອນຄຳ",
  "item.minecraft.gold_nugget": "ເສດຄຳ",
  "item.minecraft.golden_apple": "ແອັບເປິ້ນຄຳ",
  "item.minecraft.golden_axe": "ຂວານຄຳ",
  "item.minecraft.golden_boots": "ເກີບຄຳ",
  "item.minecraft.golden_carrot": "ກະຫຼົດຄຳ",
  "item.minecraft.golden_chestplate": "ເສື້ອເກາະຄຳ",
  "item.minecraft.golden_helmet": "ໝວກຄຳ",
  "item.minecraft.golden_hoe": "ຈົກຄຳ",
  "item.minecraft.golden_horse_armor": "ເກາະມ້າຄຳ",
  "item.minecraft.golden_leggings": "ໂສ້ງຄຳ",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "ອິປິກຄຳ",
  "item.minecraft.golden_shovel": "ຊວ້ານຄຳ",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "ດາບຄຳ",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "ສີຍ້ອມສີເທົາ",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "ສີຍ້ອມສີຂຽວ",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "ໄຂ່ເກີດຜູ້ພິທັກ",
  "item.minecraft.gunpowder": "ດິນປືນ",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "ຫົວໃຈແຫ່ງທະເລ",
  "item.minecraft.heart_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຫົວໃຈ",
  "item.minecraft.heart_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຫົວໃຈ",
  "item.minecraft.heartbreak_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເອິກຫັກ",
  "item.minecraft.heartbreak_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເອິກຫັກ",
  "item.minecraft.hoglin_spawn_egg": "ໄຂ່ເກີດຮ໋ອກລິນ",
  "item.minecraft.honey_bottle": "ແກ້ວນ້ຳເຜິ້ງ",
  "item.minecraft.honeycomb": "ຮວງເຜິ້ງ",
  "item.minecraft.hopper_minecart": "ລົດລາງພ້ອມທໍ່ສົ່ງ",
  "item.minecraft.horse_spawn_egg": "ໄຂ່ເກີດມ້າ",
  "item.minecraft.host_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໝາ",
  "item.minecraft.howl_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍໝາ",
  "item.minecraft.husk_spawn_egg": "ໄຂ່ເກີດຊອມບີ້ທະເລຊາຍ",
  "item.minecraft.ink_sac": "ຖົງໝຶກ",
  "item.minecraft.iron_axe": "ຂວານເຫຼັກ",
  "item.minecraft.iron_boots": "ເກີບເຫຼັກ",
  "item.minecraft.iron_chestplate": "ເສື້ອເກາະເຫຼັກ",
  "item.minecraft.iron_golem_spawn_egg": "ໄຂ່ເກີດໂກເລັມເຫຼັກ",
  "item.minecraft.iron_helmet": "ໝວກເຫຼັກ",
  "item.minecraft.iron_hoe": "ຈົກເຫຼັກ",
  "item.minecraft.iron_horse_armor": "ເກາະມ້າເຫຼັກ",
  "item.minecraft.iron_ingot": "ກ້ອນເຫຼັກ",
  "item.minecraft.iron_leggings": "ໂສ້ງເຫຼັກ",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "ເສດເຫຼັກ",
  "item.minecraft.iron_pickaxe": "ອິປິກເຫຼັກ",
  "item.minecraft.iron_shovel": "ຊວ້ານເຫຼັກ",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "ດາບເຫຼັກ",
  "item.minecraft.item_frame": "ຂອບໄອເທັມ",
  "item.minecraft.jungle_boat": "ເຮືອໄມ້ປ່າດົງດິບ",
  "item.minecraft.jungle_chest_boat": "ເຮືອໄມ້ປ່າດົງດິບພ້ອມຫີບ",
  "item.minecraft.knowledge_book": "ປຶ້ມຄວາມຮູ້",
  "item.minecraft.lapis_lazuli": "ເພທູນ",
  "item.minecraft.lava_bucket": "ຄຸລາວາ",
  "item.minecraft.lead": "ເຊືອກຈູງ",
  "item.minecraft.leather": "ໜັງ",
  "item.minecraft.leather_boots": "ເກີບໜັງ",
  "item.minecraft.leather_chestplate": "ເສື້ອເກາະໜັງ",
  "item.minecraft.leather_helmet": "ໝວກໜັງ",
  "item.minecraft.leather_horse_armor": "ເກາະມ້າໜັງ",
  "item.minecraft.leather_leggings": "ໂສ້ງໜັງ",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "ສີຍ້ອມສີຟ້າອ່ອນ",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "ສີຍ້ອມສີເທົາອ່ອນ",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "ສີຍ້ອມສີຂຽວອ່ອນ",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "ນ້ຳຢາແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.awkward": "ນ້ຳຢາເງິງະແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.empty": "ນ້ຳຢາແບບລະເຫີຍທີ່ບໍ່ສາມາດປຸງໄດ້",
  "item.minecraft.lingering_potion.effect.fire_resistance": "ນ້ຳຢາທົນໄຟແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.harming": "ນ້ຳຢາເສຍເລືອດແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.healing": "ນ້ຳຢາຟື້ນຟູແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "ນ້ຳຢາລ່ອງຫົນແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.leaping": "ນ້ຳຢາໂດດສູງແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.levitation": "ນ້ຳຢາລອຍໂຕແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.luck": "ນ້ຳຢາໂຊກດີແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.mundane": "ນ້ຳຢາປົກກະຕິແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.night_vision": "ນ້ຳຢາແນມເຫັນກາງຄືນແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "ນ້ຳຢາພິດແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.regeneration": "ນ້ຳຢາຟື້ນຟູຕໍ່ເນື່ອງແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.slow_falling": "ນ້ຳຢາຕົກນຸ້ມນວນແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.slowness": "ນ້ຳຢາເຍີບຍາບແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.strength": "ນ້ຳຢາໂຈມຕີແຮງແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.swiftness": "ນ້ຳຢາຄ່ອງແຄ່ວແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.thick": "ນ້ຳຢາເຂັ້ມຂຸ້ນແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.turtle_master": "ນ້ຳຢາປະລາມະຈານເຕົ່າແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.water": "ແກ້ວນ້ຳແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.water_breathing": "ນ້ຳຢາຫາຍໃຈກ້ອງນ້ຳແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.weakness": "ນ້ຳຢາໂຈມຕີຄ່ອຍແບບລະເຫີຍ",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "ໄຂ່ເກີດລາມະ",
  "item.minecraft.lodestone_compass": "ເຂັມທິດຫີນນຳທາງ",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "ສີຍ້ອມສີມ້ວງແດງ",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "ຄຣີມແມັກມ່າ",
  "item.minecraft.magma_cube_spawn_egg": "ໄຂ່ເກີດແມັກມ່າກະລ໋ອກ",
  "item.minecraft.mangrove_boat": "ເຮືອໄມ້ໂກງກາງ",
  "item.minecraft.mangrove_chest_boat": "ເຮືອໄມ້ໂກງກາງພ້ອມຫີບ",
  "item.minecraft.map": "ແຜນທີ່ເປົ່າ",
  "item.minecraft.melon_seeds": "ເມັດໝາກໂມ",
  "item.minecraft.melon_slice": "ປ່ຽງໝາກໂມ",
  "item.minecraft.milk_bucket": "ຄຸນົມ",
  "item.minecraft.minecart": "ລົດລາງ",
  "item.minecraft.miner_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍອິປິກ",
  "item.minecraft.miner_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍອິປິກ",
  "item.minecraft.mojang_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.mojang_banner_pattern.desc": "ໂມຈາງ",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "ໄຂ່ເກີດມູດຣູມ",
  "item.minecraft.mourner_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍວໍຣ໌ເດັນ",
  "item.minecraft.mourner_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍວໍຣ໌ເດັນ",
  "item.minecraft.mule_spawn_egg": "ໄຂ່ເກີດລວາ",
  "item.minecraft.mushroom_stew": "ສະຕູເຫັດ",
  "item.minecraft.music_disc_11": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "ແຜ່ນສຽງ",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "ຊີ້ນແກະດິບ",
  "item.minecraft.name_tag": "ປ້າຍ​ຊື່",
  "item.minecraft.nautilus_shell": "ເປືອກຫອຍງວງຊ້າງ",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "ດິນຈີ່ເນເທີ",
  "item.minecraft.nether_star": "ດາວເນເທີ",
  "item.minecraft.nether_wart": "ຂີ້ກະຕອດເນເທີ",
  "item.minecraft.netherite_axe": "ຂວານເນເທີໄຣ",
  "item.minecraft.netherite_boots": "ເກີບເນເທີໄຣ",
  "item.minecraft.netherite_chestplate": "ເສື້ອເກາະເນເທີໄຣ",
  "item.minecraft.netherite_helmet": "ໝວກເນເທີໄຣ",
  "item.minecraft.netherite_hoe": "ຈົກເນເທີໄຣ",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "ກ້ອນເນີເທີໄຣ",
  "item.minecraft.netherite_leggings": "ໂສ້ງເນເທີໄຣ",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "ອິປິກເນເທີໄຣ",
  "item.minecraft.netherite_scrap": "ເສດເນເທີໄຣ",
  "item.minecraft.netherite_shovel": "ຊວ້ານເນເທີໄຣ",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "ດາບເນເທີໄຣ",
  "item.minecraft.netherite_upgrade_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "ເຮືອໄມ້ໂອກ",
  "item.minecraft.oak_chest_boat": "ເຮືອໄມ້ໂອກພ້ອມຫີບ",
  "item.minecraft.ocelot_spawn_egg": "ໄຂ່ເກີດແມວປ່າ",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "ສີຍ້ອມສີສົ້ມ",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "ຮູບແຕ້ມ",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "ໄຂ່ເກີດໝີແພນດ້າ",
  "item.minecraft.paper": "ເຈ້ຍ",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "ໄຂ່ເກີດນົກແກ້ວ",
  "item.minecraft.phantom_membrane": "ເຍື່ອແຟນທ່ອມ",
  "item.minecraft.phantom_spawn_egg": "ໄຂ່ເກີດແຟນທ່ອມ",
  "item.minecraft.pig_spawn_egg": "ໄຂ່ເກີດໝູ",
  "item.minecraft.piglin_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.piglin_banner_pattern.desc": "ດັງໝູ",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "ໄຂ່ເກີດພິກລິນຈອມໂຫດ",
  "item.minecraft.piglin_spawn_egg": "ໄຂ່ເກີດພິກລິນ",
  "item.minecraft.pillager_spawn_egg": "ໄຂ່ເກີດກອງໂຈນ",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "ສີຍ້ອມສີບົວ",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "ຕົ້ນໝໍ້ເຂົ້າໝໍ້ແກງລິງ",
  "item.minecraft.pitcher_pod": "ເມັດໝໍ້ເຂົ້າໝໍ້ແກງລິງ",
  "item.minecraft.plenty_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເສດຖີ",
  "item.minecraft.plenty_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເສດຖີ",
  "item.minecraft.poisonous_potato": "ມັນຝຣັ່ງພິດ",
  "item.minecraft.polar_bear_spawn_egg": "ໄຂ່ເກີດໝີຂົ້ວໂລກ",
  "item.minecraft.popped_chorus_fruit": "ໝາກຄໍຣັສສຸກ",
  "item.minecraft.porkchop": "ຊີ້ນໝູດິບ",
  "item.minecraft.potato": "ມັນຝຣັ່ງ",
  "item.minecraft.potion": "ນ້ຳຢາ",
  "item.minecraft.potion.effect.awkward": "ນ້ຳຢາເງິງະ",
  "item.minecraft.potion.effect.empty": "ນ້ຳຢາທີ່ບໍ່ສາມາດປຸງໄດ້",
  "item.minecraft.potion.effect.fire_resistance": "ນ້ຳຢາທົນໄຟ",
  "item.minecraft.potion.effect.harming": "ນ້ຳຢາເສຍເລືອດ",
  "item.minecraft.potion.effect.healing": "ນ້ຳຢາຟື້ນຟູ",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "ນ້ຳຢາລ່ອງຫົນ",
  "item.minecraft.potion.effect.leaping": "ນ້ຳຢາໂດດສູງ",
  "item.minecraft.potion.effect.levitation": "ນ້ຳຢາລອຍໂຕ",
  "item.minecraft.potion.effect.luck": "ນ້ຳຢາໂຊກດີ",
  "item.minecraft.potion.effect.mundane": "ນ້ຳຢາປົກກະຕິ",
  "item.minecraft.potion.effect.night_vision": "ນ້ຳຢາແນມເຫັນກາງຄືນ",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "ນ້ຳຢາພິດ",
  "item.minecraft.potion.effect.regeneration": "ນ້ຳຢາຟື້ນຟູຕໍ່ເນື່ອງ",
  "item.minecraft.potion.effect.slow_falling": "ນ້ຳຢາຕົກນຸ້ມນວນ",
  "item.minecraft.potion.effect.slowness": "ນ້ຳຢາເຍີບຍາບ",
  "item.minecraft.potion.effect.strength": "ນ້ຳຢາໂຈມຕີແຮງ",
  "item.minecraft.potion.effect.swiftness": "ນ້ຳຢາຄ່ອງແຄ່ວ",
  "item.minecraft.potion.effect.thick": "ນ້ຳຢາເຂັ້ມຂຸ້ນ",
  "item.minecraft.potion.effect.turtle_master": "ນ້ຳຢາປະລາມະຈານເຕົ່າ",
  "item.minecraft.potion.effect.water": "ແກ້ວນ້ຳ",
  "item.minecraft.potion.effect.water_breathing": "ນ້ຳຢາຫາຍໃຈກ້ອງນ້ຳ",
  "item.minecraft.potion.effect.weakness": "ນ້ຳຢາໂຈມຕີຄ່ອຍ",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍທະນູ",
  "item.minecraft.pottery_shard_arms_up": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຄົນຍົກແຂນ",
  "item.minecraft.pottery_shard_prize": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເພັດ",
  "item.minecraft.pottery_shard_skull": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຫົວກະໂຫຼກ",
  "item.minecraft.powder_snow_bucket": "ຄຸຫິມະຜົງ",
  "item.minecraft.prismarine_crystals": "ຜະລຶກພຣິສມາຣີນ",
  "item.minecraft.prismarine_shard": "ເສດພຣິສມາຣີນ",
  "item.minecraft.prize_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເພັດ",
  "item.minecraft.prize_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍເພັດ",
  "item.minecraft.pufferfish": "ປາປັກເປົ້າ",
  "item.minecraft.pufferfish_bucket": "ຄຸປາປັກເປົ້າ",
  "item.minecraft.pufferfish_spawn_egg": "ໄຂ່ເກີດປາປັກເປົ້າ",
  "item.minecraft.pumpkin_pie": "ພາຍໝາກອຶ",
  "item.minecraft.pumpkin_seeds": "ເມັດໝາກອຶ",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "ສີຍ້ອມສີມ້ວງ",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "ມະນີສິລາເນເທີ",
  "item.minecraft.rabbit": "ຊີ້ນກະຕ່າຍດິບ",
  "item.minecraft.rabbit_foot": "ຕີນກະຕ່າຍ",
  "item.minecraft.rabbit_hide": "ໜັງກະຕ່າຍ",
  "item.minecraft.rabbit_spawn_egg": "ໄຂ່ເກີດກະຕ່າຍ",
  "item.minecraft.rabbit_stew": "ສະຕູກະຕ່າຍ",
  "item.minecraft.raiser_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "ໄຂ່ເກີດຜີສາດປຸ້ນສະດົມ",
  "item.minecraft.raw_copper": "ທອງແດງດິບ",
  "item.minecraft.raw_gold": "ຄຳດິບ",
  "item.minecraft.raw_iron": "ເຫຼັກດິບ",
  "item.minecraft.recovery_compass": "ເຂັມທິດຫວນຄືນ",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "ສີຍ້ອມສີແດງ",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "ຜົງຫີນແດງ",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "ຊີ້ນເນົ່າ",
  "item.minecraft.saddle": "ອານ",
  "item.minecraft.salmon": "ປາແຊວມອນດິບ",
  "item.minecraft.salmon_bucket": "ຄຸປາແຊວມອນ",
  "item.minecraft.salmon_spawn_egg": "ໄຂ່ເກີດປາແຊວມອນ",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍມັດເຂົ້າ",
  "item.minecraft.sheaf_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍມັດເຂົ້າ",
  "item.minecraft.shears": "ມີດຕັດ",
  "item.minecraft.sheep_spawn_egg": "ໄຂ່ເກີດແກະ",
  "item.minecraft.shelter_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຮົ່ມໄມ້",
  "item.minecraft.shelter_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຮົ່ມໄມ້",
  "item.minecraft.shield": "ໂລ້",
  "item.minecraft.shield.black": "ໂລ້ສີດຳ",
  "item.minecraft.shield.blue": "ໂລ້ສີຟ້າ",
  "item.minecraft.shield.brown": "ໂລ້ສີນ້ຳຕານ",
  "item.minecraft.shield.cyan": "ໂລ້ສີຟ້າໃສ",
  "item.minecraft.shield.gray": "ໂລ້ສີເທົາ",
  "item.minecraft.shield.green": "ໂລ້ສີຂຽວ",
  "item.minecraft.shield.light_blue": "ໂລ້ສີຟ້າອ່ອນ",
  "item.minecraft.shield.light_gray": "ໂລ້ສີເທົາອ່ອນ",
  "item.minecraft.shield.lime": "ໂລ້ສີຂຽວອ່ອນ",
  "item.minecraft.shield.magenta": "ໂລ້ສີມ້ວງແດງ",
  "item.minecraft.shield.orange": "ໂລ້ສີສົ້ມ",
  "item.minecraft.shield.pink": "ໂລ້ສີບົວ",
  "item.minecraft.shield.purple": "ໂລ້ສີມ້ວງ",
  "item.minecraft.shield.red": "ໂລ້ສີແດງ",
  "item.minecraft.shield.white": "ໂລ້ສີຂາວ",
  "item.minecraft.shield.yellow": "ໂລ້ສີເຫຼືອງ",
  "item.minecraft.shulker_shell": "ເປືອກເຊົາເກີ",
  "item.minecraft.shulker_spawn_egg": "ໄຂ່ເກີດເຊົາເກີ",
  "item.minecraft.sign": "ປ້າຍ",
  "item.minecraft.silence_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "ໄຂ່ເກີດແມງສາມງ່າມ",
  "item.minecraft.skeleton_horse_spawn_egg": "ໄຂ່ເກີດມ້າໂຄງກະດູກ",
  "item.minecraft.skeleton_spawn_egg": "ໄຂ່ເກີດໂຄງກະດູກ",
  "item.minecraft.skull_banner_pattern": "ແບບລາຍທຸງ",
  "item.minecraft.skull_banner_pattern.desc": "ກາສັນຍະລັກຫົວກະໂຫຼກ",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຫົວກະໂຫຼກ",
  "item.minecraft.skull_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍຫົວກະໂຫຼກ",
  "item.minecraft.slime_ball": "ກ້ອນສະລາມ",
  "item.minecraft.slime_spawn_egg": "ໄຂ່ເກີດສະລາມ",
  "item.minecraft.smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.smithing_template.applies_to": "ໃຊ້ກັບ:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "ເພີ່ມກ້ອນແຮ່ ຫຼື ຜະລຶກ",
  "item.minecraft.smithing_template.armor_trim.applies_to": "ເກາະ",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "ເພີ່ມເສດເກາະ",
  "item.minecraft.smithing_template.armor_trim.ingredients": "ກ້ອນແຮ່ ແລະ ຜະລຶກ",
  "item.minecraft.smithing_template.ingredients": "ສ່ວນປະກອບ:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "ເພີ່ມກ້ອນເນີເທີໄຣ",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ອຸປະກອນເພັດ",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "ເພີ່ມເກາະ, ອາວຸດ ຫຼື ເຄື່ອງມືເພັດ",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "ກ້ອນເນີເທີໄຣ",
  "item.minecraft.smithing_template.upgrade": "ອັບເກຣດ: ",
  "item.minecraft.sniffer_spawn_egg": "ໄຂ່ເກີດສະນິບເຟີ",
  "item.minecraft.snort_pottery_shard": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍສະນິບເຟີ",
  "item.minecraft.snort_pottery_sherd": "ເສດເຄື່ອງປັ້ນດິນເຜົາລາຍສະນິບເຟີ",
  "item.minecraft.snout_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "ໄຂ່ເກີດໂກເລັມຫິມະ",
  "item.minecraft.snowball": "ກ້ອນຫິມະ",
  "item.minecraft.spectral_arrow": "ລູກທະນູເຮືອງແສງ",
  "item.minecraft.spider_eye": "ຕາແມງມຸມ",
  "item.minecraft.spider_spawn_egg": "ໄຂ່ເກີດແມງມຸມ",
  "item.minecraft.spire_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "ນ້ຳຢາແບບດຶກ",
  "item.minecraft.splash_potion.effect.awkward": "ນ້ຳຢາເງິງະແບບດຶກ",
  "item.minecraft.splash_potion.effect.empty": "ນ້ຳຢາແບບດຶກທີ່ບໍ່ສາມາດປຸງໄດ້",
  "item.minecraft.splash_potion.effect.fire_resistance": "ນ້ຳຢາທົນໄຟດຶກ",
  "item.minecraft.splash_potion.effect.harming": "ນ້ຳຢາເສຍເລືອດແບບດຶກ",
  "item.minecraft.splash_potion.effect.healing": "ນ້ຳຢາຟື້ນຟູແບບດຶກ",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "ນ້ຳຢາລ່ອງຫົນແບບດຶກ",
  "item.minecraft.splash_potion.effect.leaping": "ນ້ຳຢາໂດດສູງແບບດຶກ",
  "item.minecraft.splash_potion.effect.levitation": "ນ້ຳຢາລອຍໂຕແບບດຶກ",
  "item.minecraft.splash_potion.effect.luck": "ນ້ຳຢາໂຊກດີແບບດຶກ",
  "item.minecraft.splash_potion.effect.mundane": "ນ້ຳຢາປົກກະຕິແບບດຶກ",
  "item.minecraft.splash_potion.effect.night_vision": "ນ້ຳຢາແນມເຫັນກາງຄືນແບບດຶກ",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "ນ້ຳຢາພິດແບບດຶກ",
  "item.minecraft.splash_potion.effect.regeneration": "ນ້ຳຢາຟື້ນຟູຕໍ່ເນື່ອງແບບດຶກ",
  "item.minecraft.splash_potion.effect.slow_falling": "ນ້ຳຢາຕົກນຸ້ມນວນແບບດຶກ",
  "item.minecraft.splash_potion.effect.slowness": "ນ້ຳຢາເຍີບຍາບແບບດຶກ",
  "item.minecraft.splash_potion.effect.strength": "ນ້ຳຢາໂຈມຕີແຮງແບບດຶກ",
  "item.minecraft.splash_potion.effect.swiftness": "ນ້ຳຢາຄ່ອງແຄ່ວແບບດຶກ",
  "item.minecraft.splash_potion.effect.thick": "ນ້ຳຢາເຂັ້ມຂຸ້ນແບບດຶກ",
  "item.minecraft.splash_potion.effect.turtle_master": "ນ້ຳຢາປະລາມະຈານເຕົ່າແບບດຶກ",
  "item.minecraft.splash_potion.effect.water": "ແກ້ວນ້ຳແບບດຶກ",
  "item.minecraft.splash_potion.effect.water_breathing": "ນ້ຳຢາຫາຍໃຈກ້ອງນ້ຳແບບດຶກ",
  "item.minecraft.splash_potion.effect.weakness": "ນ້ຳຢາໂຈມຕີຄ່ອຍແບບດຶກ",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "ເຮືອໄມ້ສະປຣູດ",
  "item.minecraft.spruce_chest_boat": "ເຮືອໄມ້ສະປຣູດພ້ອມຫີບ",
  "item.minecraft.spyglass": "ກ້ອງສອດແນມ",
  "item.minecraft.squid_spawn_egg": "ໄຂ່ເກີດປາໝຶກ",
  "item.minecraft.stick": "ແທ່ງໄມ້",
  "item.minecraft.stone_axe": "ຂວານຫີນ",
  "item.minecraft.stone_hoe": "ຈົກຫີນ",
  "item.minecraft.stone_pickaxe": "ອິປິກຫີນ",
  "item.minecraft.stone_shovel": "ຊວ້ານຫີນ",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "ດາບຫີນ",
  "item.minecraft.stray_spawn_egg": "ໄຂ່ເກີດໂຄງກະດູກນ້ຳກ້ອນ",
  "item.minecraft.strider_spawn_egg": "ໄຂ່ເກີດສະໄຕຣເດີ",
  "item.minecraft.string": "ເສັ້ນໃຍ",
  "item.minecraft.sugar": "ນ້ຳຕານ",
  "item.minecraft.suspicious_stew": "ສະຕູໜ້າສົງໄສ",
  "item.minecraft.sweet_berries": "ເບີຣີ່ຫວານ",
  "item.minecraft.tadpole_bucket": "ຄຸໂຕຮວກ",
  "item.minecraft.tadpole_spawn_egg": "ໄຂ່ເກີດຮວກ",
  "item.minecraft.tide_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "ລູກທະນູອາບຢາ",
  "item.minecraft.tipped_arrow.effect.awkward": "ລູກທະນູອາບຢາ",
  "item.minecraft.tipped_arrow.effect.empty": "ລູກທະນູອາບຢາທີ່ບໍ່ສາມາດຄຣາບໄດ້",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "ລູກທະນູອາບຢາທົນໄຟ",
  "item.minecraft.tipped_arrow.effect.harming": "ລູກທະນູອາບຢາເສຍເລືອດ",
  "item.minecraft.tipped_arrow.effect.healing": "ລູກທະນູອາບຢາຟື້ນຟູ",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "ລູກທະນູອາບຢາລ່ອງຫົນ",
  "item.minecraft.tipped_arrow.effect.leaping": "ລູກທະນູອາບຢາໂດດສູງ",
  "item.minecraft.tipped_arrow.effect.levitation": "ລູກທະນູອາບຢາລອຍໂຕ",
  "item.minecraft.tipped_arrow.effect.luck": "ລູກທະນູອາບຢາໂຊກດີ",
  "item.minecraft.tipped_arrow.effect.mundane": "ລູກທະນູອາບຢາ",
  "item.minecraft.tipped_arrow.effect.night_vision": "ລູກທະນູອາບຢາແນມເຫັນກາງຄືນ",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "ລູກທະນູອາບຢາພິດ",
  "item.minecraft.tipped_arrow.effect.regeneration": "ລູກທະນູອາບຢາຟື້ນຟູຕໍ່ເນື່ອງ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "ລູກທະນູອາບຢາຕົກນຸ້ມນວນ",
  "item.minecraft.tipped_arrow.effect.slowness": "ລູກທະນູອາບຢາເຍີບຍາບ",
  "item.minecraft.tipped_arrow.effect.strength": "ລູກທະນູອາບຢາໂຈມຕີແຮງ",
  "item.minecraft.tipped_arrow.effect.swiftness": "ລູກທະນູອາບຢາຄ່ອງແຄ່ວ",
  "item.minecraft.tipped_arrow.effect.thick": "ລູກທະນູອາບຢາ",
  "item.minecraft.tipped_arrow.effect.turtle_master": "ລູກທະນູອາບຢາປະລາມະຈານເຕົ່າ",
  "item.minecraft.tipped_arrow.effect.water": "ລູກທະນູອາບນ້ຳ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "ລູກທະນູອາບຢາຫາຍໃຈກ້ອງນ້ຳ",
  "item.minecraft.tipped_arrow.effect.weakness": "ລູກທະນູອາບຢາໂຈມຕີຄ່ອຍ",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "ລົດລາງພ້ອມລະເບີດທີເອັນທີ",
  "item.minecraft.torchflower_seeds": "ເມັດດອກຄົບໄຟ",
  "item.minecraft.totem_of_undying": "ເຄື່ອງລາງບໍ່ມີມື້ຕາຍ",
  "item.minecraft.trader_llama_spawn_egg": "ໄຂ່ເກີດລາມະພໍ່ຄ້າ",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "ສາມງ່າມ",
  "item.minecraft.tropical_fish": "ປາເຂດຮ້ອນ",
  "item.minecraft.tropical_fish_bucket": "ຄຸປາເຂດຮ້ອນ",
  "item.minecraft.tropical_fish_spawn_egg": "ໄຂ່ເກີດປາເຂດຮ້ອນ",
  "item.minecraft.turtle_helmet": "ກະດອງເຕົ່າ",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "ໄຂ່ເກີດເຕົ່າ",
  "item.minecraft.vex_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "ໄຂ່ເກີດເວກ",
  "item.minecraft.villager_spawn_egg": "ໄຂ່ເກີດຊາວບ້ານ",
  "item.minecraft.vindicator_spawn_egg": "ໄຂ່ເກີດວິນດິເຄເຕີ",
  "item.minecraft.wandering_trader_spawn_egg": "ໄຂ່ເກີດພໍ່ຄ້າຮ່ວນແຮ່",
  "item.minecraft.ward_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "ໄຂ່ເກີດວໍຣ໌ເດັນ",
  "item.minecraft.warped_fungus_on_a_stick": "ເຫັດເຊື້ອລາຜີບ້າຕິດເບັດ",
  "item.minecraft.water_bucket": "ຄຸນ້ຳ",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "ເຂົ້າສາລີ",
  "item.minecraft.wheat_seeds": "ເມັດເຂົ້າສາລີ",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "ສີຍ້ອມສີຂາວ",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "ແມ່ພິມຫຼອມ",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "ໄຂ່ເກີດແມ່ມົດ",
  "item.minecraft.wither_skeleton_spawn_egg": "ໄຂ່ເກີດໂຄງກະດູກວິດເທີ",
  "item.minecraft.wither_spawn_egg": "ໄຂ່ເກີດວິດເທີ",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "ໄຂ່ເກີດໝາປ່າ",
  "item.minecraft.wooden_axe": "ຂວານໄມ້",
  "item.minecraft.wooden_hoe": "ຈົກໄມ້",
  "item.minecraft.wooden_pickaxe": "ອິປິກໄມ້",
  "item.minecraft.wooden_shovel": "ຊວ້ານໄມ້",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "ດາບໄມ້",
  "item.minecraft.writable_book": "ປຶ້ມກັບບິກຂົນນົກ",
  "item.minecraft.written_book": "ປຶ້ມຂຽນແລ້ວ",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "ສີຍ້ອມສີເຫຼືອງ",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "ໄຂ່ເກີດຊ໋ອກລິນ",
  "item.minecraft.zombie_horse_spawn_egg": "ໄຂ່ເກີດມ້າຊອມບີ້",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "ໄຂ່ເກີດຊອມບີ້",
  "item.minecraft.zombie_villager_spawn_egg": "ໄຂ່ເກີດຊາວບ້ານຊອມບີ້",
  "item.minecraft.zombified_piglin_spawn_egg": "ໄຂ່ເກີດພິກລິນຊອມບີ້"
}
export const lo_la = items; 
